<template>
  <div>
    <!-- show loading indicator -->
    <loading-indicator :loading="isLoading"></loading-indicator>

    <template v-if="!isLoading">
      <template v-if="siteCatalog == null"> </template>

      <template v-else>
        <!-- page header -->
        <page-heading
          :show="true"
          :pageTitle="siteCatalog.site.name"
        ></page-heading>

        <first-level-nav
          :mainTab="mainTab"
          :site="siteCatalog"
          @setActiveTab="setMainTab"
        ></first-level-nav>

        <div class="columns">
          <div class="col-main">
            <div style="padding: 20px 0">
              <tabs
                :key="mainTab"
                type="boxed"
                size="normal"
                :on-tab-click="tabClicked"
                :class="{
                  showTabApopoint:
                    userRole == 'Administrator' && siteCatalog.site.hasApoPoint,
                }"
              >
                <!-- tab BASE DATA -->
                <tab-item
                  :label="$t('APO_TAB-BASE_DATA')"
                  v-if="tabs.includes('baseData')"
                >
                  <div class="section-header">
                    <label-name
                      labelKey="SITE_CATALOG-HEADLINE-BASE_DATA"
                    ></label-name>
                  </div>
                  <div class="section">
                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name labelKey="SITE_EXTREF"></label-name>
                      </div>
                      <div class="control">
                        <input
                          id="SITE_EXTREF"
                          class="input"
                          type="number"
                          min="0"
                          v-model.number="siteCatalog.site.extRef"
                          readonly
                        />
                      </div>
                    </div>

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name labelKey="SITE_NAME"></label-name>
                      </div>
                      <div class="control">
                        <input
                          id="SITE_NAME"
                          class="input"
                          type="text"
                          v-model="siteCatalog.site.name"
                          readonly
                        />
                      </div>
                    </div>

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name labelKey="SITE_CONTACT_OWNER"></label-name>
                      </div>
                      <div class="control">
                        <input
                          id="SITE_CONTACT_OWNER"
                          class="input"
                          type="text"
                          v-model="siteCatalog.site.contactPerson.fullName"
                          readonly
                        />
                      </div>
                    </div>

                    <br />
                    <br />

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name labelKey="SITE_ADDRESS"></label-name>
                      </div>
                      <div class="control">
                        <input
                          id="SITE_ADDRESS"
                          class="input"
                          type="text"
                          v-model="siteCatalog.site.address"
                          readonly
                        />
                      </div>
                    </div>

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name labelKey="SITE_ZIPCODE"></label-name>
                      </div>
                      <div class="control">
                        <input
                          id="SITE_ZIPCODE"
                          class="input"
                          type="number"
                          min="0"
                          v-model.number="siteCatalog.site.zipcode"
                          readonly
                        />
                      </div>
                    </div>

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name labelKey="SITE_CITY"></label-name>
                      </div>
                      <div class="control">
                        <input
                          id="SITE_CITY"
                          class="input"
                          type="text"
                          v-model="siteCatalog.site.city"
                          readonly
                        />
                      </div>
                    </div>

                    <br />
                    <br />

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name labelKey="SITE_PHONE"></label-name>
                      </div>
                      <div class="control">
                        <input
                          id="SITE_PHONE"
                          class="input"
                          type="text"
                          v-model="siteCatalog.site.phone"
                          readonly
                        />
                      </div>
                    </div>

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name labelKey="SITE_FAX"></label-name>
                      </div>
                      <div class="control">
                        <input
                          id="SITE_FAX"
                          class="input"
                          type="text"
                          v-model="siteCatalog.site.fax"
                          readonly
                        />
                      </div>
                    </div>

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name labelKey="SITE_EMAIL"></label-name>
                      </div>
                      <div class="control">
                        <input
                          id="SITE_EMAIL"
                          class="input"
                          type="text"
                          v-model="siteCatalog.site.email"
                          readonly
                        />
                      </div>
                    </div>

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name labelKey="SITE_WEBSITE"></label-name>
                      </div>
                      <div class="control">
                        <input
                          id="SITE_WEBSITE"
                          class="input"
                          type="text"
                          v-model="siteCatalog.site.website"
                          readonly
                        />
                      </div>
                    </div>
                    <br />
                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name labelKey="SITE_SUPERVISOR"></label-name>
                      </div>
                      <div class="control">
                        <input
                          id="SITE_SUPERVISOR"
                          class="input"
                          type="text"
                          v-model="siteCatalog.site.accountManager.fullName"
                          readonly
                        />
                      </div>
                    </div>

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name labelKey="SITE_HERBA_KEY"></label-name>
                      </div>
                      <div class="control">
                        <input
                          id="SITE_HERBA_KEY"
                          class="input"
                          type="number"
                          min="0"
                          v-model.number="siteCatalog.site.herbaKey"
                          readonly
                        />
                      </div>
                    </div>
                  </div>

                  <div class="section-header">
                    <label-name
                      labelKey="SITE_CATALOG-HEADLINE-BOOKED_SERVICES"
                    ></label-name>
                  </div>

                  <div class="section">
                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE_CATALOG_HAS_NEWSLETTER"
                        ></label-name>
                      </div>
                      <div class="control">
                        <b-switch
                          v-model.sync="siteCatalog.site.newsletter"
                          type="primary"
                          size="small"
                          :disabled="isReadOnly"
                        ></b-switch>
                      </div>
                    </div>
                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE_CATALOG_HAS_SOCIAL_MEDIA"
                        ></label-name>
                      </div>
                      <div class="control">
                        <b-switch
                          v-model.sync="siteCatalog.site.socialMedia"
                          type="primary"
                          size="small"
                          :disabled="isReadOnly"
                        ></b-switch>
                      </div>
                    </div>

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE_APOPOINT_CONTENT_FEED"
                        ></label-name>
                      </div>
                      <div class="control">
                        <b-switch
                          v-model.sync="siteCatalog.site.apopointContentFeed"
                          type="primary"
                          size="small"
                          :disabled="isReadOnly"
                        ></b-switch>
                      </div>
                    </div>

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name labelKey="SITE-HAS_APOPOINT"></label-name>
                      </div>
                      <div class="control">
                        <b-switch
                          v-model.sync="siteCatalog.site.hasApoPoint"
                          type="primary"
                          size="small"
                          :disabled="isReadOnly"
                        ></b-switch>
                      </div>
                    </div>
                  </div>

                  <div class="section-header">
                    <label-name
                      labelKey="SITE_CATALOG-HEADLINE-COMMUNICATION_PLATFORM_SETTINGS"
                    ></label-name>
                  </div>
                  <div class="section">
                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE-NEWSLETTER-CHEFINFO-ACTIVE"
                        ></label-name>
                      </div>
                      <div class="control">
                        <b-switch
                          v-model.sync="
                            siteCatalog.site.isChefinfoNewsletterRecipient
                          "
                          type="primary"
                          size="small"
                          :disabled="isReadOnly"
                        ></b-switch>
                      </div>
                    </div>

                    <template
                      v-if="siteCatalog.site.isChefinfoNewsletterRecipient"
                    >
                      <form-input
                        label="SITE-NEWSLETTER-CHEFINFO-GENDER"
                        :showLabel="true"
                        :showLabelInOptions="true"
                        inputType="select"
                        selectFieldName="name"
                        :selectOptions="personGenders"
                        v-model="
                          siteCatalog.site.chefinfoNewsletterRecipient.gender
                        "
                        :is-horizontal="true"
                      ></form-input>
                      <form-input
                        label="SITE-NEWSLETTER-CHEFINFO-TITLE"
                        :inputType="text"
                        v-model="
                          siteCatalog.site.chefinfoNewsletterRecipient.title
                        "
                        :is-horizontal="true"
                      ></form-input>
                      <form-input
                        label="SITE-NEWSLETTER-CHEFINFO-FIRSTNAME"
                        :inputType="text"
                        v-model="
                          siteCatalog.site.chefinfoNewsletterRecipient.firstname
                        "
                        :is-horizontal="true"
                      ></form-input>
                      <form-input
                        label="SITE-NEWSLETTER-CHEFINFO-LASTNAME"
                        :inputType="text"
                        v-model="
                          siteCatalog.site.chefinfoNewsletterRecipient.lastname
                        "
                        :is-horizontal="true"
                      ></form-input>
                      <form-input
                        label="SITE-NEWSLETTER-CHEFINFO-EMAIL"
                        :inputType="text"
                        v-model="
                          siteCatalog.site.chefinfoNewsletterRecipient.email
                        "
                        :is-horizontal="true"
                      ></form-input>

                      <div
                        class="control is-horizontal"
                        v-if="
                          siteCatalog.site.chefinfoNewsletterRecipient
                            .createdBy != null
                        "
                      >
                        <div class="control-label"></div>
                        <div class="control">
                          <small
                            >hinzugefügt von
                            {{
                              getCreatedByName(
                                siteCatalog.site.chefinfoNewsletterRecipient
                                  .createdBy
                              )
                            }}
                            am
                            {{
                              formatDate2(
                                siteCatalog.site.chefinfoNewsletterRecipient
                                  .createdAt
                              )
                            }}</small
                          >
                        </div>
                      </div>
                    </template>

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE-NEWSLETTER-BEIRATSNEWSLETTER-ACTIVE"
                        ></label-name>
                      </div>
                      <div class="control">
                        <b-switch
                          v-model.sync="
                            siteCatalog.site.isBeiratsNewsNewsletterRecipient
                          "
                          type="primary"
                          size="small"
                          :disabled="isReadOnly"
                        ></b-switch>
                      </div>
                    </div>

                    <template
                      v-if="siteCatalog.site.isBeiratsNewsNewsletterRecipient"
                    >
                      <form-input
                        label="SITE-NEWSLETTER-CHEFINFO-GENDER"
                        :showLabel="true"
                        :showLabelInOptions="true"
                        inputType="select"
                        selectFieldName="name"
                        :selectOptions="personGenders"
                        v-model="
                          siteCatalog.site.beiratsNewsNewsletterRecipient.gender
                        "
                        :is-horizontal="true"
                      ></form-input>
                      <form-input
                        label="SITE-NEWSLETTER-BEIRAT-TITLE"
                        :inputType="text"
                        v-model="
                          siteCatalog.site.beiratsNewsNewsletterRecipient.title
                        "
                        :is-horizontal="true"
                      ></form-input>
                      <form-input
                        label="SITE-NEWSLETTER-BEIRAT-FIRSTNAME"
                        :inputType="text"
                        v-model="
                          siteCatalog.site.beiratsNewsNewsletterRecipient
                            .firstname
                        "
                        :is-horizontal="true"
                      ></form-input>
                      <form-input
                        label="SITE-NEWSLETTER-BEIRAT-LASTNAME"
                        :inputType="text"
                        v-model="
                          siteCatalog.site.beiratsNewsNewsletterRecipient
                            .lastname
                        "
                        :is-horizontal="true"
                      ></form-input>
                      <form-input
                        label="SITE-NEWSLETTER-BEIRAT-EMAIL"
                        :inputType="text"
                        v-model="
                          siteCatalog.site.beiratsNewsNewsletterRecipient.email
                        "
                        :is-horizontal="true"
                      ></form-input>

                      <div
                        class="control is-horizontal"
                        v-if="
                          siteCatalog.site.beiratsNewsNewsletterRecipient
                            .createdBy != null
                        "
                      >
                        <div class="control-label"></div>
                        <div class="control">
                          <small
                            >hinzugefügt von
                            {{
                              getCreatedByName(
                                siteCatalog.site.beiratsNewsNewsletterRecipient
                                  .createdBy
                              )
                            }}
                            am
                            {{
                              formatDate2(
                                siteCatalog.site.beiratsNewsNewsletterRecipient
                                  .createdAt
                              )
                            }}</small
                          >
                        </div>
                      </div>
                    </template>
                  </div>

                  <div class="section-header">
                    <label-name
                      labelKey="SITE_CATALOG-HEADLINE-MARKETING_COCKPIT_SETTINGS"
                    ></label-name>
                  </div>
                  <div class="section">
                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name labelKey="SITE_FACEBOOOK"></label-name>
                      </div>
                      <div class="control">
                        <input
                          id="SITE_FACEBOOK"
                          class="input"
                          type="text"
                          v-model="siteCatalog.site.facebook"
                        />
                      </div>
                    </div>

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name labelKey="SITE_FACEBOOOK_ID"></label-name>
                      </div>
                      <div class="control">
                        <input
                          id="SITE_FACEBOOK_ID"
                          class="input"
                          type="text"
                          v-model="siteCatalog.site.facebookPageId"
                        />
                      </div>
                    </div>

                    <br />

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE_NEWSLETTER-EMAIL"
                        ></label-name>
                      </div>
                      <div class="control">
                        <input
                          id="SITE_NEWSLETTER-EMAIL"
                          class="input"
                          type="text"
                          v-model="siteCatalog.site.emailNewsletter"
                        />
                      </div>
                    </div>

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE_NEWSLETTER-PHONE"
                        ></label-name>
                      </div>
                      <div class="control">
                        <input
                          id="SITE_NEWSLETTER-PHONE"
                          class="input"
                          type="text"
                          v-model="siteCatalog.site.phoneNewsletter"
                        />
                      </div>
                    </div>

                    <br />

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name labelKey="SITE-MARKETING_PLAN"></label-name>
                      </div>
                      <div class="control">
                        {{ siteCatalog.site.marketingPlan }}
                      </div>
                    </div>

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE-DISABLE_MARKETING_REMINDERS"
                        ></label-name>
                      </div>
                      <div class="control">
                        <b-switch
                          v-model.sync="
                            siteCatalog.site.disableMarketingReminders
                          "
                          type="primary"
                          size="small"
                          :disabled="isReadOnly"
                        ></b-switch>
                      </div>
                    </div>
                  </div>
                </tab-item>

                <!-- TAB: CATALOG DATA -->
                <tab-item
                  :label="$t('APO_TAB-CATALOG_DATA')"
                  v-if="tabs.includes('apokat')"
                >
                  <div class="section-header">
                    <label-name
                      labelKey="SITE-APOPOINT-HEADING-GENERAL_CATALOG_DATA"
                    ></label-name>
                  </div>

                  <div class="section">
                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE_CATALOG_IS_SUBSCRIPTION"
                        ></label-name>
                      </div>
                      <div class="control">
                        <b-switch
                          v-model.sync="siteCatalog.isSubscription"
                          type="primary"
                          size="small"
                          :disabled="isReadOnly"
                        ></b-switch>
                      </div>
                    </div>

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name labelKey="SITE_CATALOG_QTY"></label-name>
                      </div>
                      <div class="control">
                        <input
                          id="SITE_CATALOG_QTY"
                          class="input"
                          type="number"
                          min="0"
                          v-model.number="siteCatalog.quantity"
                          :readonly="isReadOnly"
                        />
                      </div>
                    </div>

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE_CATALOG_REBATEINKIND"
                        ></label-name>
                      </div>
                      <div class="control">
                        <input
                          id="SITE_CATALOG_REBATEINKIND"
                          class="input"
                          type="text"
                          v-model="siteCatalog.rebateInKind"
                          :readonly="isReadOnly"
                        />
                      </div>
                    </div>

                    <br />

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE_CATALOG_HAS_SHIPMENT"
                        ></label-name>
                      </div>
                      <div class="control">
                        <b-switch
                          v-model.sync="siteCatalog.hasShipment"
                          type="primary"
                          size="small"
                          :disabled="isReadOnly"
                        ></b-switch>
                      </div>
                    </div>

                    <transition name="slide-fade" appear>
                      <div v-if="siteCatalog.hasShipment">
                        <div class="control is-horizontal">
                          <div class="control-label">
                            <label-name
                              labelKey="SITE_CATALOG_HAS_SHIPMENT_RECIPIENT_LIST"
                            ></label-name>
                          </div>
                          <div class="control">
                            <b-switch
                              v-model.sync="
                                siteCatalog.hasShipmentRecipientList
                              "
                              type="primary"
                              size="small"
                              :disabled="isReadOnly"
                            ></b-switch>
                          </div>
                        </div>

                        <div class="control is-horizontal">
                          <div class="control-label">
                            <label-name
                              labelKey="SITE_CATALOG_SHIPMENT_RECIPIENT_LIST"
                            ></label-name>
                          </div>
                          <div class="control">
                            <input
                              id="SITE_CATALOG_SHIPMENT_RECIPIENT_LIST"
                              class="input"
                              type="number"
                              min="0"
                              v-model.number="
                                siteCatalog.shipmentRecipientListQty
                              "
                              :readonly="isReadOnly"
                            />
                          </div>
                        </div>

                        <div class="control is-horizontal">
                          <div class="control-label">
                            <label-name
                              labelKey="SITE_CATALOG_SHIPMENT_AREA_ZIPCODES"
                            ></label-name>
                          </div>
                          <div class="control">
                            <input
                              id="SITE_CATALOG_SHIPMENT_AREA_ZIPCODES"
                              class="input"
                              type="text"
                              v-model="siteCatalog.shipmentAreaZipcodes"
                              :readonly="isReadOnly"
                            />
                          </div>
                        </div>

                        <div class="control is-horizontal">
                          <div class="control-label">
                            <label-name
                              labelKey="SITE_CATALOG_SHIPMENT_AREA_QTY"
                            ></label-name>
                          </div>
                          <div class="control">
                            <input
                              id="SITE_CATALOG_SHIPMENT_AREA_QTY"
                              class="input"
                              type="number"
                              min="0"
                              v-model.number="siteCatalog.shipmentAreaQty"
                              :readonly="isReadOnly"
                            />
                          </div>
                        </div>

                        <br />
                        <br />
                      </div>
                    </transition>

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE_CATALOG_USE_FOIL_COATING"
                        ></label-name>
                      </div>
                      <div class="control">
                        <b-switch
                          v-model.sync="siteCatalog.useFoilCoating"
                          type="primary"
                          size="small"
                          :disabled="isReadOnly"
                        ></b-switch>
                      </div>
                    </div>

                    <!-- Change Request #10745 -->
                    <transition
                      name="slide-fade"
                      appear
                      v-if="userRole == 'Administrator'"
                    >
                      <div
                        class="control is-horizontal"
                        v-if="siteCatalog.useFoilCoating"
                      >
                        <div class="control-label">
                          <label-name
                            labelKey="SITE_CATALOG_USE_FOIL_COATING_REST"
                          ></label-name>
                        </div>
                        <div class="control">
                          <b-switch
                            v-model.sync="
                              siteCatalog.useFoilCoatingForRemainingQuantity
                            "
                            type="primary"
                            size="small"
                            :disabled="isReadOnly"
                          ></b-switch>
                        </div>
                      </div>
                    </transition>

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE_CATALOG_PROMOTION_MATERIAL_PACKAGE_QTY"
                        ></label-name>
                      </div>
                      <div class="control">
                        <input
                          id="SITE_CATALOG_PROMOTION_MATERIAL_PACKAGE_QTY"
                          class="input"
                          type="number"
                          min="0"
                          v-model.number="
                            siteCatalog.promotionMaterialPackageQty
                          "
                          :readonly="isReadOnly"
                        />
                      </div>
                    </div>

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE_CATALOG_HAS_COUPON_BOX"
                        ></label-name>
                      </div>
                      <div class="control">
                        <input
                          id="SITE_CATALOG_HAS_COUPON_BOX"
                          class="input"
                          type="number"
                          min="0"
                          v-model.number="siteCatalog.couponBoxQty"
                          :readonly="isReadOnly"
                        />
                      </div>
                    </div>

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE_CATALOG_COUPONS_QTY"
                        ></label-name>
                      </div>
                      <div class="control">
                        <input
                          id="SITE_CATALOG_COUPONS_QTY"
                          class="input"
                          type="number"
                          min="0"
                          v-model.number="siteCatalog.couponSetQty"
                          :readonly="isReadOnly"
                        />
                      </div>
                    </div>

                    <br />

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE_CATALOG_IS_CANCELLED"
                        ></label-name>
                      </div>
                      <div class="control">
                        <b-switch
                          v-model.sync="siteCatalog.isCancelled"
                          type="primary"
                          size="small"
                          :disabled="isReadOnly"
                        ></b-switch>
                      </div>
                    </div>

                    <transition name="slide-fade" appear>
                      <div
                        class="control is-horizontal"
                        v-if="siteCatalog.isCancelled"
                      >
                        <div class="control-label">
                          <label-name
                            labelKey="SITE_CATALOG_CANCELLATION_REASON"
                          ></label-name>
                        </div>
                        <div class="control">
                          <input
                            id="SITE_CATALOG_CANCELLATION_REASON"
                            class="input"
                            type="text"
                            v-model="siteCatalog.cancellationReason"
                            :readonly="isReadOnly"
                          />
                        </div>
                      </div>
                    </transition>

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name labelKey="SITE_ACQUIRED_BY"></label-name>
                      </div>
                      <div class="control">
                        <input
                          id="SITE_ACQUIRED_BY"
                          class="input"
                          type="text"
                          v-model="siteCatalog.site.acquiredBy"
                          :readonly="isReadOnly"
                        />
                      </div>
                    </div>

                    <br />

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE_CATALOG_COMMENT1"
                        ></label-name>
                      </div>
                      <div class="control">
                        <textarea
                          id="SITE_CATALOG_COMMENT1"
                          class="textarea"
                          type="text"
                          v-model="siteCatalog.notes"
                          :readonly="isReadOnly"
                        ></textarea>
                      </div>
                    </div>
                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE_CATALOG_COMMENT2"
                        ></label-name>
                      </div>
                      <div class="control">
                        <textarea
                          id="SITE_CATALOG_COMMENT2"
                          class="textarea"
                          type="text"
                          v-model="siteCatalog.comments"
                          :readonly="isReadOnly"
                        ></textarea>
                      </div>
                    </div>
                  </div>

                  <!-- Apokat Ansprechpartner -->
                  <div class="section-header">
                    <label-name
                      labelKey="SITE-APOPOINT-HEADING-APOKAT_CONTACT"
                    ></label-name>
                  </div>
                  <div class="section">
                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name labelKey="SITE_CONTACT_PERSON"></label-name>
                      </div>
                      <div class="control">
                        <input
                          id="SITE_CONTACT_PERSON"
                          class="input"
                          type="text"
                          v-model="siteCatalog.site.catalogContactPersonName"
                          :readonly="isReadOnly"
                        />
                      </div>
                    </div>

                    <!-- contact person 1 -->
                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE_CONTACT_PERSON_1"
                        ></label-name>
                      </div>
                      <div class="control">
                        <input
                          type="text"
                          readonly="readonly"
                          class="input"
                          :value="
                            showContactPerson(
                              siteCatalog.site.emailContactPerson1
                            )
                          "
                        />
                        <div class="contactPersonButtons">
                          <div
                            class="button is-single is-small is-light has-pointer"
                            @click="showPersonModal1 = true"
                          >
                            <span class="icon is-small"
                              ><i
                                :class="[
                                  siteCatalog.site.emailContactPerson1 != null
                                    ? 'icon-ak-bearbeiten'
                                    : 'icon-ak-hinzufuegen',
                                ]"
                              ></i
                            ></span>
                          </div>
                          <div
                            class="button is-single is-small is-light has-pointer"
                            v-if="siteCatalog.site.emailContactPerson1 != null"
                            @click="siteCatalog.site.emailContactPerson1 = null"
                          >
                            <span class="icon is-small"
                              ><i class="icon-ak-entfernen"></i
                            ></span>
                          </div>
                        </div>
                        <edit-person
                          :show="showPersonModal1"
                          modalTitle="Kontaktperson 1 bearbeiten"
                          :person="siteCatalog.site.emailContactPerson1"
                          @save="
                            updateEmailContact(
                              'emailContactPerson1',
                              ...arguments
                            )
                          "
                          @close="showPersonModal1 = false"
                        ></edit-person>
                      </div>
                    </div>

                    <!-- contact person 2 -->
                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE_CONTACT_PERSON_2"
                        ></label-name>
                      </div>
                      <div class="control">
                        <input
                          type="text"
                          readonly="readonly"
                          class="input"
                          :value="
                            showContactPerson(
                              siteCatalog.site.emailContactPerson2
                            )
                          "
                        />
                        <div class="contactPersonButtons">
                          <div
                            class="button is-single is-small is-light has-pointer"
                            @click="showPersonModal2 = true"
                          >
                            <span class="icon is-small"
                              ><i
                                :class="[
                                  siteCatalog.site.emailContactPerson2 != null
                                    ? 'icon-ak-bearbeiten'
                                    : 'icon-ak-hinzufuegen',
                                ]"
                              ></i
                            ></span>
                          </div>
                          <div
                            class="button is-single is-small is-light has-pointer"
                            v-if="siteCatalog.site.emailContactPerson2 != null"
                            @click="siteCatalog.site.emailContactPerson2 = null"
                          >
                            <span class="icon is-small"
                              ><i class="icon-ak-entfernen"></i
                            ></span>
                          </div>
                        </div>
                        <edit-person
                          :show="showPersonModal2"
                          modalTitle="Kontaktperson 2 bearbeiten"
                          :person="siteCatalog.site.emailContactPerson2"
                          @save="
                            updateEmailContact(
                              'emailContactPerson2',
                              ...arguments
                            )
                          "
                          @close="showPersonModal2 = false"
                        ></edit-person>
                      </div>
                    </div>

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE_NEWSLETTER_CONTACT_PERSON"
                        ></label-name>
                      </div>
                      <div class="control">
                        <input
                          id="SITE_NEWSLETTER_CONTACT_PERSON"
                          class="input"
                          type="text"
                          v-model="
                            siteCatalog.site
                              .newsletterSocialMediaContactPersonName
                          "
                          :readonly="isReadOnly"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- Apokat Digital -->
                  <div class="section-header">
                    <label-name
                      labelKey="SITE-APOPOINT-HEADING-APOKAT_DIGITAL_SETTINGS"
                    ></label-name>
                  </div>

                  <div class="section">
                    <div class="control groupTitle">
                      <div class="control-label">
                        <lang labelKey="OPENING HOURS"></lang>
                      </div>
                    </div>
                    <div
                      class="control is-horizontal"
                      v-for="(item, key) in siteCatalog.site.openingHours"
                      :key="item.id"
                    >
                      <div class="control-label">
                        <label-name
                          :labelKey="
                            'DAY_' +
                            siteCatalog.site.openingHours[key].dayInWeek
                          "
                        ></label-name>
                      </div>

                      <div class="control is-grouped">
                        <p class="control">
                          <input
                            type="text"
                            class="input"
                            v-model="
                              siteCatalog.site.openingHours[key].openTime
                            "
                            v-isoToString="
                              siteCatalog.site.openingHours[key].openTime
                            "
                            :readonly="isReadOnly"
                          />
                        </p>
                        <p class="control separator">-</p>
                        <p class="control">
                          <input
                            type="text"
                            class="input"
                            v-model="
                              siteCatalog.site.openingHours[key].closeTime
                            "
                            v-isoToString="
                              siteCatalog.site.openingHours[key].closeTime
                            "
                            :readonly="isReadOnly"
                          />
                        </p>

                        <p
                          class="control buttons"
                          v-if="userRole != 'Kundenbetreuer'"
                        >
                          <pop-confirm
                            v-if="!isReadOnly"
                            :content="$t('CONFIRMATION-DELETE_OPENING_HOUR')"
                            icon="question-circle-o"
                            cancel-text="abbrechen"
                            :on-ok="
                              function () {
                                removeOpeningDay(key);
                              }
                            "
                          >
                            <span
                              :class="[
                                { 'is-disabled': isReadOnly },
                                'button is-single is-small is-light',
                              ]"
                            >
                              <span class="icon is-small">
                                <i class="icon-ak-entfernen-2"></i>
                              </span>
                            </span>
                          </pop-confirm>

                          <span
                            :class="[
                              { 'is-disabled': isReadOnly },
                              'button is-single is-small is-light',
                            ]"
                            @click="addOpeningDay(key)"
                          >
                            <span class="icon is-small">
                              <i class="icon-ak-hinzufuegen"></i>
                            </span>
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </tab-item>

                <!-- TAB: MUTATIONEN -->
                <tab-item
                  :label="$t('APO_TAB-MUTATIONS')"
                  v-if="tabs.includes('apokatMutationen')"
                >
                  <div class="control is-horizontal">
                    <div class="control-label">
                      <label-name
                        labelKey="SITE_CATALOG_HAS_CUSTOM_DESIGN"
                      ></label-name>
                    </div>
                    <div class="control">
                      <b-switch
                        v-model.sync="siteCatalog.hasCustomDesign"
                        type="primary"
                        size="small"
                        :disabled="isReadOnly"
                      ></b-switch>
                    </div>
                  </div>

                  <div class="control is-horizontal">
                    <div class="control-label">
                      <label-name labelKey="SITE_CATALOG_VOUCHERS"></label-name>
                    </div>
                    <div class="control">
                      <span class="control select">
                        <select
                          id="SITE_CATALOG_MUTATIONS"
                          v-model="siteCatalog.voucherPackage"
                          :disabled="isReadOnly"
                        >
                          <option
                            v-for="(term, key) in voucherPackages"
                            :value="term"
                          >
                            {{ $t("SELECT_VOUCHER-" + key) }}
                          </option>
                        </select>
                      </span>
                    </div>
                  </div>

                  <div
                    class="control is-horizontal"
                    v-if="siteCatalog.voucherPackage.name != 'NO_VOUCHERS'"
                  >
                    <div class="control-label">
                      <label-name
                        labelKey="SITE_CATALOG_CUSTOM_VOUCHER_PRICE"
                      ></label-name>
                    </div>
                    <div class="control">
                      <input
                        class="input"
                        type="text"
                        v-model="siteCatalog.customeVoucherPrice"
                        :readonly="isReadOnly"
                      />
                    </div>
                  </div>

                  <div class="control is-horizontal">
                    <div class="control-label">
                      <label-name
                        labelKey="SITE_CATALOG_MUTATIONS"
                      ></label-name>
                    </div>
                    <div class="control">
                      <span class="control select">
                        <select
                          id="SITE_CATALOG_MUTATIONS"
                          v-model="siteCatalog.package"
                          :disabled="isReadOnly"
                        >
                          <option :value="null">
                            {{ $t("SELECT_BOX-MUTATION_NONE") }}
                          </option>
                          <option
                            v-for="(
                              term, key
                            ) in siteCatalogCustomizationPackages"
                            :value="term"
                            selected="siteCatalog.package.id == term.id ? 'selected' : ''"
                          >
                            {{ $t("MUTATION_" + key) }}
                          </option>
                        </select>
                      </span>
                    </div>
                  </div>

                  <div
                    class="control is-horizontal"
                    v-if="siteCatalog.package != null"
                  >
                    <div class="control-label">
                      <label-name
                        labelKey="SITE_CATALOG_CUSTOM_CUSTOMIZATION_PRICE"
                      ></label-name>
                    </div>
                    <div class="control">
                      <input
                        class="input"
                        type="text"
                        v-model="siteCatalog.customeCustomizationPrice"
                        :readonly="isReadOnly"
                      />
                    </div>
                  </div>

                  <transition name="slide-fade-up" tag="div" appear>
                    <!-- Mutation PACKAGE 1 -->
                    <template
                      v-if="
                        siteCatalog.package &&
                        siteCatalog.package.name == 'U1_U4'
                      "
                    >
                      <div>
                        <div class="control groupTitle">
                          <div class="control-label">
                            <lang
                              :labelKey="
                                'HEADING-MUTATION' +
                                (this.isSupplement ? '-SUP' : '') +
                                '_U1_U4'
                              "
                            >
                            </lang>
                          </div>
                        </div>

                        <div class="control is-horizontal">
                          <div class="control-label">
                            <label-name
                              labelKey="SITE_CATALOG_CHANGES_U1"
                            ></label-name>
                          </div>
                          <span class="control select">
                            <select
                              id="SITE_CATALOG_CHANGES_U1"
                              v-model="
                                siteCatalog.siteCatalogCustomizations[0]
                                  .changeExpendituresAmount
                              "
                              :disabled="isReadOnly"
                            >
                              <option
                                v-for="(
                                  term, key
                                ) in siteCatalogCustomizationExpenses"
                                :value="term.id"
                              >
                                {{
                                  $t(
                                    "TERM_SITE_CATALOG_CUSTOMIZATION_EXPENSES_U1_" +
                                      key
                                  )
                                }}
                              </option>
                            </select>
                          </span>
                        </div>

                        <div class="control is-horizontal">
                          <div class="control-label">
                            <label-name
                              labelKey="SITE_CATALOG_COMMENT_U1"
                            ></label-name>
                          </div>
                          <div class="control">
                            <textarea
                              id="SITE_CATALOG_COMMENT_U1"
                              class="textarea"
                              type="text"
                              v-model="
                                siteCatalog.siteCatalogCustomizations[0]
                                  .comments
                              "
                              :readonly="isReadOnly"
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </template>

                    <!-- Mutation PACKAGE 2 -->
                    <template
                      v-else-if="
                        siteCatalog.package &&
                        siteCatalog.package.name == 'U1_U4_U2'
                      "
                    >
                      <div>
                        <div class="control groupTitle">
                          <div class="control-label">
                            <lang
                              :labelKey="
                                'HEADING-MUTATION' +
                                (this.isSupplement ? '-SUP' : '') +
                                '_U1_U4'
                              "
                            >
                            </lang>
                          </div>
                        </div>

                        <div class="control is-horizontal">
                          <div class="control-label">
                            <label-name
                              labelKey="SITE_CATALOG_CHANGES_U1"
                            ></label-name>
                          </div>
                          <span class="control select">
                            <select
                              id="SITE_CATALOG_CHANGES_U1"
                              v-model="
                                siteCatalog.siteCatalogCustomizations[0]
                                  .changeExpendituresAmount
                              "
                              :disabled="isReadOnly"
                            >
                              <option
                                v-for="(
                                  term, key
                                ) in siteCatalogCustomizationExpenses"
                                :value="term.id"
                              >
                                {{
                                  $t(
                                    "TERM_SITE_CATALOG_CUSTOMIZATION_EXPENSES_U1_" +
                                      key
                                  )
                                }}
                              </option>
                            </select>
                          </span>
                        </div>

                        <div class="control is-horizontal">
                          <div class="control-label">
                            <label-name
                              labelKey="SITE_CATALOG_COMMENT_U1"
                            ></label-name>
                          </div>
                          <div class="control">
                            <textarea
                              id="SITE_CATALOG_COMMENT_U1"
                              class="textarea"
                              type="text"
                              v-model="
                                siteCatalog.siteCatalogCustomizations[0]
                                  .comments
                              "
                              :readonly="isReadOnly"
                            ></textarea>
                          </div>
                        </div>

                        <br />

                        <div class="control groupTitle">
                          <div class="control-label">
                            <lang
                              :labelKey="
                                'HEADING-MUTATION' +
                                (this.isSupplement ? '-SUP' : '') +
                                '_U1_U4_U2'
                              "
                            >
                            </lang>
                          </div>
                        </div>

                        <div class="control is-horizontal">
                          <div class="control-label">
                            <label-name
                              labelKey="SITE_CATALOG_CHANGES_U2"
                            ></label-name>
                          </div>
                          <div class="control">
                            <span class="control select">
                              <select
                                id="SITE_CATALOG_CHANGES_U2"
                                v-model="
                                  siteCatalog.siteCatalogCustomizations[1]
                                    .changeExpendituresAmount
                                "
                                :disabled="isReadOnly"
                              >
                                <option
                                  v-for="(
                                    term, key
                                  ) in siteCatalogCustomizationExpenses"
                                  :value="term.id"
                                >
                                  {{
                                    $t(
                                      "TERM_SITE_CATALOG_CUSTOMIZATION_EXPENSES_U2_" +
                                        key
                                    )
                                  }}
                                </option>
                              </select>
                            </span>
                          </div>
                        </div>

                        <div class="control is-horizontal">
                          <div class="control-label">
                            <label-name
                              labelKey="SITE_CATALOG_COMMENT_U2"
                            ></label-name>
                          </div>
                          <div class="control">
                            <textarea
                              id="SITE_CATALOG_COMMENT_U2"
                              class="textarea"
                              type="text"
                              v-model="
                                siteCatalog.siteCatalogCustomizations[1]
                                  .comments
                              "
                              :readonly="isReadOnly"
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </template>

                    <!-- Mutation PACKAGE 3 -->
                    <template
                      v-else-if="
                        siteCatalog.package &&
                        siteCatalog.package.name == 'U1_U4_U2_US'
                      "
                    >
                      <div>
                        <div class="control groupTitle">
                          <div class="control-label">
                            <lang
                              :labelKey="
                                'HEADING-MUTATION' +
                                (this.isSupplement ? '-SUP' : '') +
                                '_U1_U4'
                              "
                            >
                            </lang>
                          </div>
                        </div>

                        <div class="control is-horizontal">
                          <div class="control-label">
                            <label-name
                              labelKey="SITE_CATALOG_CHANGES_U1"
                            ></label-name>
                          </div>
                          <div class="control">
                            <span class="control select">
                              <select
                                id="SITE_CATALOG_CHANGES_U1"
                                v-model="
                                  siteCatalog.siteCatalogCustomizations[0]
                                    .changeExpendituresAmount
                                "
                                :disabled="isReadOnly"
                              >
                                <option
                                  v-for="(
                                    term, key
                                  ) in siteCatalogCustomizationExpenses"
                                  :value="term.id"
                                >
                                  {{
                                    $t(
                                      "TERM_SITE_CATALOG_CUSTOMIZATION_EXPENSES_U1_" +
                                        key
                                    )
                                  }}
                                </option>
                              </select>
                            </span>
                          </div>
                        </div>
                        <div class="control is-horizontal">
                          <div class="control-label">
                            <label-name
                              labelKey="SITE_CATALOG_COMMENT_U1"
                            ></label-name>
                          </div>
                          <div class="control">
                            <textarea
                              id="SITE_CATALOG_COMMENT_U1"
                              class="textarea"
                              type="text"
                              v-model="
                                siteCatalog.siteCatalogCustomizations[0]
                                  .comments
                              "
                              :readonly="isReadOnly"
                            ></textarea>
                          </div>
                        </div>

                        <br />

                        <div class="control groupTitle">
                          <div class="control-label">
                            <lang
                              :labelKey="
                                'HEADING-MUTATION' +
                                (this.isSupplement ? '-SUP' : '') +
                                '_U1_U4_U2'
                              "
                            >
                            </lang>
                          </div>
                        </div>

                        <div class="control is-horizontal">
                          <div class="control-label">
                            <label-name
                              labelKey="SITE_CATALOG_CHANGES_U2"
                            ></label-name>
                          </div>
                          <div class="control">
                            <span class="control select">
                              <select
                                id="SITE_CATALOG_CHANGES_U2"
                                v-model="
                                  siteCatalog.siteCatalogCustomizations[1]
                                    .changeExpendituresAmount
                                "
                                :disabled="isReadOnly"
                              >
                                <option
                                  v-for="(
                                    term, key
                                  ) in siteCatalogCustomizationExpenses"
                                  :value="term.id"
                                >
                                  {{
                                    $t(
                                      "TERM_SITE_CATALOG_CUSTOMIZATION_EXPENSES_U2_" +
                                        key
                                    )
                                  }}
                                </option>
                              </select>
                            </span>
                          </div>
                        </div>

                        <div class="control is-horizontal">
                          <div class="control-label">
                            <label-name
                              labelKey="SITE_CATALOG_COMMENT_U2"
                            ></label-name>
                          </div>
                          <div class="control">
                            <textarea
                              id="SITE_CATALOG_COMMENT_U2"
                              class="textarea"
                              type="text"
                              v-model="
                                siteCatalog.siteCatalogCustomizations[1]
                                  .comments
                              "
                              :readonly="isReadOnly"
                            ></textarea>
                          </div>
                        </div>

                        <br />

                        <div class="control groupTitle">
                          <div class="control-label">
                            <lang
                              :labelKey="
                                'HEADING-MUTATION' +
                                (this.isSupplement ? '-SUP' : '') +
                                '_U1_U4_US'
                              "
                            >
                            </lang>
                          </div>
                        </div>

                        <div class="control is-horizontal">
                          <div class="control-label">
                            <label-name
                              labelKey="SITE_CATALOG_CHANGES_US"
                            ></label-name>
                          </div>
                          <div class="control">
                            <span class="control select">
                              <select
                                id="SITE_CATALOG_CHANGES_US"
                                v-model="
                                  siteCatalog.siteCatalogCustomizations[2]
                                    .changeExpendituresAmount
                                "
                                :disabled="isReadOnly"
                              >
                                <option
                                  v-for="(
                                    term, key
                                  ) in siteCatalogCustomizationExpenses"
                                  :value="term.id"
                                >
                                  {{
                                    $t(
                                      "TERM_SITE_CATALOG_CUSTOMIZATION_EXPENSES_US_" +
                                        key
                                    )
                                  }}
                                </option>
                              </select>
                            </span>
                          </div>
                        </div>

                        <div class="control is-horizontal">
                          <div class="control-label">
                            <label-name
                              labelKey="SITE_CATALOG_COMMENT_US"
                            ></label-name>
                          </div>
                          <div class="control">
                            <textarea
                              id="SITE_CATALOG_COMMENT_US"
                              class="textarea"
                              type="text"
                              v-model="
                                siteCatalog.siteCatalogCustomizations[2]
                                  .comments
                              "
                              :readonly="isReadOnly"
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </template>
                  </transition>

                  <template
                    v-if="
                      siteCatalog.voucherPackage != null &&
                      siteCatalog.voucherPackage.name != 'NO_VOUCHERS'
                    "
                  >
                    <div class="control groupTitle">
                      <div class="control-label">
                        <lang labelKey="HEADING-VOUCHERS"></lang>
                      </div>
                    </div>

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE_CATALOG_CHANGES_VOUCHERS"
                        ></label-name>
                      </div>
                      <div class="control">
                        <span class="control select">
                          <select
                            id="SITE_CATALOG_CHANGES_VOUCHERS"
                            v-model="
                              siteCatalog.voucherChangeExpendituresAmount
                            "
                            :disabled="isReadOnly"
                          >
                            <option
                              v-for="(
                                term, key
                              ) in siteCatalogCustomizationExpenses"
                              :value="term.id"
                            >
                              {{ $t("MUTATION_EXPENSE_" + key) }}
                            </option>
                          </select>
                        </span>
                      </div>
                    </div>

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE_CATALOG_COMMENT_VOUCHER"
                        ></label-name>
                      </div>
                      <div class="control">
                        <textarea
                          id="SITE_CATALOG_COMMENT_VOUCHER"
                          class="textarea"
                          type="text"
                          v-model="siteCatalog.voucherComments"
                          :readonly="isReadOnly"
                        ></textarea>
                      </div>
                    </div>
                  </template>
                </tab-item>

                <!-- TAB: DATA -->
                <tab-item
                  :label="$t('APO_TAB-DATA')"
                  v-if="tabs.includes('apokatDaten')"
                >
                  <!-- Logo Upload Field -->
                  <div
                    class="control is-horizontal"
                    v-if="userRole != 'Kundenbetreuer'"
                  >
                    <div class="control-label">
                      <label-name
                        labelKey="SITE_CATALOG_UPLOAD_LOGO"
                      ></label-name>
                    </div>

                    <div class="control">
                      <vue-dropzone
                        ref="vueDropzoneLogo"
                        id="vueDropzoneLogo"
                        url="fileProcessing/upload?preset=logo"
                        :maxFiles="1"
                        :isEnabled="userRole != 'Kundenbetreuer'"
                        dictDefaultMessage="<i class='fa fa-cloud-upload'></i>Logo hochladen"
                        v-on:vdropzone-success="dzLogoSuccess"
                        dzClass="default"
                      >
                      </vue-dropzone>
                    </div>
                  </div>

                  <div
                    class="control is-horizontal"
                    v-if="siteCatalog.site.logoAsset != null"
                  >
                    <div class="control-label"></div>
                    <div class="control">
                      <assets
                        :assets="[{ asset: siteCatalog.site.logoAsset }]"
                        @removeAsset="siteCatalog.site.logoAsset = null"
                        :isReadOnly="isReadOnly"
                      ></assets>
                    </div>
                  </div>

                  <div
                    class="control is-horizontal"
                    v-if="userRole != 'Kundenbetreuer'"
                  >
                    <div class="control-label">
                      <label-name
                        labelKey="MUTATION-UPLOAD_FILE_BOX"
                      ></label-name>
                      <!--
										<tooltip content="ein PDF hochladen, wobei pro Mutation eine PDF Seite gegeben sein muss." placement="top">
											<span class="icon is-small"><i class="fa fa-question-circle" aria-hidden="true"></i></span>
										</tooltip>
										-->
                    </div>

                    <div class="control">
                      <mutation-preview-dropzone
                        modalTitle="CATALOG_PAGE-PREVIEW_UPLOAD"
                        @finish="dzMutationPreviewSucess"
                      ></mutation-preview-dropzone>
                    </div>
                  </div>

                  <template v-if="siteCatalog.package != null">
                    <!--
									<template v-for="(category, index) in siteCatalogContentCategories" v-if="inCategory(category) && (category.name != 'CONTACT_CARD' || (siteCatalog.voucherPackage != null && siteCatalog.voucherPackage.name == 'NO_VOUCHERS'))">
									-->
                    <div
                      :class="category.name"
                      v-for="(category, index) in siteCatalogContentCategories"
                    >
                      <div class="control groupTitle">
                        <div class="control-label">
                          <lang
                            :labelKey="'APO_CATEGORY-' + category.name"
                          ></lang>
                        </div>
                      </div>

                      <div class="columns">
                        <div class="column">
                          <div
                            class="control is-horizontal"
                            v-if="userRole != 'Kundenbetreuer'"
                          >
                            <div class="control-label">
                              <label-name
                                labelKey="SITE_CATALOG_UPLOAD_FILE_BOX"
                              ></label-name>
                            </div>

                            <div class="control">
                              <vue-dropzone
                                :ref="'vueDropzone' + category.id"
                                :id="'vueDropzone' + index"
                                url="fileProcessing/upload?preset=siteCatalogAsset"
                                :formDataAppend="[{ category: category.id }]"
                                :isClickable="true"
                                dictDefaultMessage="<i class='fa fa-cloud-upload'></i>Datei hochladen"
                                v-on:vdropzone-success="
                                  dzSiteCatalogAssetSuccess($event, category.id)
                                "
                                dzClass="default"
                              >
                              </vue-dropzone>
                            </div>
                          </div>

                          <template
                            v-if="
                              siteCatalog.siteCatalogAssets.length > 0 &&
                              userRole != 'Kundenbetreuer'
                            "
                          >
                            <div class="control is-horizontal">
                              <div class="control-label"></div>
                              <div class="control">
                                <assets
                                  :assets="siteCatalog.siteCatalogAssets"
                                  :specialCondition="true"
                                  :isReadOnly="isReadOnly"
                                  :conditionId="parseInt(category.id)"
                                  :key="category.id"
                                  @removeAsset="removeAsset"
                                >
                                </assets>
                              </div>
                            </div>
                          </template>

                          <!-- Text Fields -->
                          <content-segment
                            :catalogContents="siteCatalog.siteCatalogContents"
                            :categoryId="category.id"
                            :category="category"
                            :isReadOnly="isReadOnly"
                            @addTextBox="addContentField"
                            @removeTextBox="removeContentField"
                            v-model="siteCatalog"
                          >
                          </content-segment>

                          <!-- COMMENTS -->
                          <template
                            v-for="customization in siteCatalog.siteCatalogCustomizations"
                          >
                            <template
                              v-if="
                                category.data.catalogPageCustomization !=
                                  null &&
                                customization.type ==
                                  category.data.catalogPageCustomization
                              "
                            >
                              <br />
                              <div
                                class="control is-horizontal"
                                v-if="category.data.showComments"
                              >
                                <div class="control-label">
                                  <label-name
                                    labelKey="APO_SITE_CATALOG_CUSTOMIZATION-COMMENTS"
                                  ></label-name>
                                </div>

                                <div class="control comments">
                                  <comments
                                    :showHeader="false"
                                    :showAvatars="false"
                                    :smallView="true"
                                    headerTitle="APO_DETAIL-COMMENTS_HEADER"
                                    :threadID.sync="customization.thread"
                                    :api="
                                      'siteCatalogCustomization/' +
                                      customization.id
                                    "
                                    :isReadOnly="isReadOnly"
                                  ></comments>
                                </div>
                              </div>
                            </template>
                          </template>
                        </div>

                        <div class="column">
                          <template
                            v-for="customization in siteCatalog.siteCatalogCustomizations"
                          >
                            <template
                              v-if="
                                category.data.catalogPageCustomization !=
                                  null &&
                                customization.type ==
                                  category.data.catalogPageCustomization
                              "
                            >
                              <div
                                :class="[
                                  'previewWrapper is-pulled-right',
                                  { isSupplement: isSupplement },
                                  category.name,
                                  index,
                                ]"
                              >
                                <template v-if="customization.preview != null">
                                  <div
                                    class="preview lazy-img-fadein"
                                    v-lazy:background-image="
                                      getImgUrl(customization)
                                    "
                                    :key="customization"
                                  ></div>

                                  <a
                                    :href="getPdfDownloadUrl(customization)"
                                    :download="
                                      siteCatalog.site.extRef +
                                      '-' +
                                      customization.preview.filename
                                        .split('.')
                                        .shift()
                                        .split('-')
                                        .pop() +
                                      '.pdf'
                                    "
                                    class="dlButton"
                                  >
                                    <button
                                      class="button is-outline is-small is-dark"
                                    >
                                      <span class="icon is-small"
                                        ><i class="icon-ak-download"></i
                                      ></span>
                                      {{ $t("BTN-CATALOG_PAGES-DOWNLOAD_PDF") }}
                                    </button>
                                  </a>
                                </template>

                                <template v-else>
                                  <div class="preview noImg"></div>
                                </template>
                              </div>
                            </template>
                          </template>
                        </div>
                      </div>
                    </div>
                    <!-- loop -->
                  </template>
                  <!-- siteCatalog.package != null -->

                  <!-- VOUCHERS -->
                  <template
                    v-if="
                      (siteCatalog.voucherPackage &&
                        siteCatalog.voucherPackage.name == 'VOUCHERS_3') ||
                      (siteCatalog.voucherPackage &&
                        siteCatalog.voucherPackage.name == 'VOUCHERS_6')
                    "
                  >
                    <div class="control groupTitle">
                      <div class="control-label">
                        <lang labelKey="APO_CATEGORY-VOUCHERS"></lang>
                      </div>
                    </div>

                    <div class="columns">
                      <div class="column">
                        <!-- 3 GS -->
                        <template
                          v-if="
                            siteCatalog.voucherPackage &&
                            siteCatalog.voucherPackage.name == 'VOUCHERS_3'
                          "
                        >
                          <div>
                            <div class="control is-horizontal">
                              <div class="control-label">
                                <label-name
                                  labelKey="SITE_CATALOG_VOUCHER_TEXT_1"
                                ></label-name>
                              </div>
                              <div class="control">
                                <textarea
                                  id="SITE_CATALOG_VOUCHER_TEXT_1"
                                  class="textarea"
                                  type="text"
                                  v-model="siteCatalog.voucherText1"
                                  :readonly="isReadOnly"
                                ></textarea>
                              </div>
                            </div>

                            <div class="control is-horizontal">
                              <div class="control-label">
                                <label-name
                                  labelKey="SITE_CATALOG_VOUCHER_TEXT_2"
                                ></label-name>
                              </div>
                              <div class="control">
                                <textarea
                                  id="SITE_CATALOG_VOUCHER_TEXT_2"
                                  class="textarea"
                                  type="text"
                                  v-model="siteCatalog.voucherText2"
                                  :readonly="isReadOnly"
                                ></textarea>
                              </div>
                            </div>

                            <div class="control is-horizontal">
                              <div class="control-label">
                                <label-name
                                  labelKey="SITE_CATALOG_VOUCHER_TEXT_3"
                                ></label-name>
                              </div>
                              <div class="control">
                                <textarea
                                  id="SITE_CATALOG_VOUCHER_TEXT_3"
                                  class="textarea"
                                  type="text"
                                  v-model="siteCatalog.voucherText3"
                                  :readonly="isReadOnly"
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </template>

                        <!-- 6 GS -->
                        <template
                          v-if="
                            siteCatalog.voucherPackage &&
                            siteCatalog.voucherPackage.name == 'VOUCHERS_6'
                          "
                        >
                          <div>
                            <div class="control is-horizontal">
                              <div class="control-label">
                                <label-name
                                  labelKey="SITE_CATALOG_VOUCHER_TEXT_1"
                                ></label-name>
                              </div>
                              <div class="control">
                                <textarea
                                  id="SITE_CATALOG_VOUCHER_TEXT_1"
                                  class="textarea"
                                  type="text"
                                  v-model="siteCatalog.voucherText1"
                                  :readonly="isReadOnly"
                                ></textarea>
                              </div>
                            </div>

                            <div class="control is-horizontal">
                              <div class="control-label">
                                <label-name
                                  labelKey="SITE_CATALOG_VOUCHER_TEXT_2"
                                ></label-name>
                              </div>
                              <div class="control">
                                <textarea
                                  id="SITE_CATALOG_VOUCHER_TEXT_2"
                                  class="textarea"
                                  type="text"
                                  v-model="siteCatalog.voucherText2"
                                  :readonly="isReadOnly"
                                ></textarea>
                              </div>
                            </div>

                            <div class="control is-horizontal">
                              <div class="control-label">
                                <label-name
                                  labelKey="SITE_CATALOG_VOUCHER_TEXT_3"
                                ></label-name>
                              </div>
                              <div class="control">
                                <textarea
                                  id="SITE_CATALOG_VOUCHER_TEXT_3"
                                  class="textarea"
                                  type="text"
                                  v-model="siteCatalog.voucherText3"
                                  :readonly="isReadOnly"
                                ></textarea>
                              </div>
                            </div>

                            <div class="control is-horizontal">
                              <div class="control-label">
                                <label-name
                                  labelKey="SITE_CATALOG_VOUCHER_TEXT_4"
                                ></label-name>
                              </div>
                              <div class="control">
                                <textarea
                                  id="SITE_CATALOG_VOUCHER_TEXT_4"
                                  class="textarea"
                                  type="text"
                                  v-model="siteCatalog.voucherText4"
                                  :readonly="isReadOnly"
                                ></textarea>
                              </div>
                            </div>

                            <div class="control is-horizontal">
                              <div class="control-label">
                                <label-name
                                  labelKey="SITE_CATALOG_VOUCHER_TEXT_5"
                                ></label-name>
                              </div>
                              <div class="control">
                                <textarea
                                  id="SITE_CATALOG_VOUCHER_TEXT_5"
                                  class="textarea"
                                  type="text"
                                  v-model="siteCatalog.voucherText5"
                                  :readonly="isReadOnly"
                                ></textarea>
                              </div>
                            </div>

                            <div class="control is-horizontal">
                              <div class="control-label">
                                <label-name
                                  labelKey="SITE_CATALOG_VOUCHER_TEXT_6"
                                ></label-name>
                              </div>
                              <div class="control">
                                <textarea
                                  id="SITE_CATALOG_VOUCHER_TEXT_6"
                                  class="textarea"
                                  type="text"
                                  v-model="siteCatalog.voucherText6"
                                  :readonly="isReadOnly"
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </template>

                        <div class="control is-horizontal">
                          <div class="control-label">
                            <label-name
                              labelKey="APO_SITE_CATALOG_CUSTOMIZATION-COMMENTS"
                            ></label-name>
                          </div>

                          <div class="control comments">
                            <comments
                              :showHeader="false"
                              :smallView="true"
                              :showAvatars="false"
                              :threadID.sync="siteCatalog.voucherThread"
                              threadFieldName="voucherThread"
                              :api="'siteCatalog/' + siteCatalog.id"
                              :isReadOnly="isReadOnly"
                            ></comments>
                          </div>
                        </div>
                      </div>

                      <div class="column">
                        <div
                          class="is-pulled-right"
                          style="display: flex; flex-direction: column"
                        >
                          <div
                            :class="[
                              'previewWrapper voucher',
                              { isSupplement: isSupplement },
                              siteCatalog.voucherPackage.name,
                            ]"
                          >
                            <template
                              v-if="
                                siteCatalog.voucherPreview &&
                                siteCatalog.voucherPreview.path != null
                              "
                            >
                              <img
                                v-lazy="
                                  $config.assets +
                                  siteCatalog.voucherPreview.path +
                                  '/' +
                                  siteCatalog.voucherPreview.filename
                                "
                                v-if="
                                  siteCatalog.voucherPreview &&
                                  siteCatalog.voucherPreview.path != null
                                "
                                class="preview"
                                :key="siteCatalog.voucherPreview"
                              />

                              <a
                                :href="getPdfDownloadUrlVoucher('front')"
                                class="dlButton"
                                :download="
                                  siteCatalog.site.extRef + '-gutscheine-1.pdf'
                                "
                                v-if="
                                  siteCatalog.voucherPreview &&
                                  siteCatalog.voucherPreview.path != null
                                "
                              >
                                <button
                                  class="button is-outline is-small is-dark"
                                >
                                  <span class="icon is-small"
                                    ><i class="icon-ak-download"></i
                                  ></span>
                                  {{ $t("BTN-CATALOG_PAGES-DOWNLOAD_PDF") }}
                                </button>
                              </a>
                            </template>

                            <template v-else>
                              <div class="preview noImg"></div>
                            </template>
                          </div>

                          <div
                            :class="[
                              'previewWrapper voucher',
                              { isSupplement: isSupplement },
                              siteCatalog.voucherPackage.name,
                            ]"
                            v-if="isSupplement"
                          >
                            <template
                              v-if="
                                siteCatalog.voucherBackPreview &&
                                siteCatalog.voucherBackPreview.path != null
                              "
                            >
                              <img
                                v-lazy="
                                  $config.assets +
                                  siteCatalog.voucherBackPreview.path +
                                  '/' +
                                  siteCatalog.voucherBackPreview.filename
                                "
                                class="preview"
                                :key="siteCatalog.voucherBackPreview"
                              />

                              <a
                                :href="getPdfDownloadUrlVoucher('back')"
                                class="dlButton"
                                :download="
                                  siteCatalog.site.extRef + '-gutscheine-2.pdf'
                                "
                              >
                                <button
                                  class="button is-outline is-small is-dark"
                                >
                                  <span class="icon is-small"
                                    ><i class="icon-ak-download"></i
                                  ></span>
                                  {{ $t("BTN-CATALOG_PAGES-DOWNLOAD_PDF") }}
                                </button>
                              </a>
                            </template>

                            <template v-else>
                              <div class="preview noImg"></div>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <!-- // Vouchers -->
                </tab-item>

                <!-- TAB: Erfolgskontrolle -->
                <tab-item
                  :label="$t('APO_TAB-SUCCESS_CONTROL')"
                  v-if="tabs.includes('apokatKontrolle')"
                >
                  <template v-if="activeTab == 'apokatKontrolle'">
                    <order-history
                      :siteId="siteCatalog.site.id"
                    ></order-history>
                  </template>
                </tab-item>

                <!-- TAB: Logs -->
                <tab-item
                  :label="$t('APO_TAB-LOG')"
                  v-if="tabs.includes('apokatLogs')"
                >
                  <template v-if="activeTab == 'apokatLogs'">
                    <log-changes
                      :logsApi="'siteCatalog/' + siteCatalog.id + '/changes'"
                    ></log-changes>
                  </template>
                </tab-item>

                <!-- tab CALENDAR -->
                <tab-item
                  :label="$t('APO_TAB-CALENDAR')"
                  v-if="tabs.includes('Calendar')"
                >
                  <template v-if="activeTab == 'Calendar'">
                    <calendar :pharmacy="siteCatalog.site"></calendar>
                  </template>
                </tab-item>

                <!-- tab EXTRAS -->
                <!--
							<tab-item :label="$t('APO_TAB-EXTRAS')" v-if="tabs.includes('Extras')">

							</tab-item>
							-->

                <!-- tab OPENING HOURS  -->
                <tab-item
                  :label="$t('APO_TAB-OPENING_HOURS')"
                  v-if="tabs.includes('tabOpeningHours')"
                >
                  <template v-if="activeTab == 'tabOpeningHours'">
                    <pharmacy-opening-hours
                      :siteId="siteCatalog.site.id"
                    ></pharmacy-opening-hours>
                  </template>
                </tab-item>

                <!-- tab APOPOINT SHOP SETTINGS -->
                <tab-item
                  :label="$t('APO_TAB-APOPOINT_SETTINGS')"
                  v-if="tabs.includes('apopointShopSettings')"
                >
                  <div class="section-header">
                    <label-name
                      labelKey="SITE-APOPOINT-HEADING-GENERAL_SETTINGS"
                    ></label-name>
                  </div>

                  <div class="section">
                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name labelKey="SITE-APOPOINT-TYPE"></label-name>
                      </div>
                      <span class="control select">
                        <select
                          v-model="siteCatalog.site.apoPointType"
                          :disabled="isReadOnly"
                        >
                          <option
                            v-for="option in apopointTypesOptions"
                            :value="option.value"
                          >
                            {{ option.displayName }}
                          </option>
                        </select>
                      </span>
                    </div>
                    <form-input
                      label="SITE-APOPOINT-KEY"
                      :inputType="text"
                      v-model="siteCatalog.site.apopointKey"
                      :is-horizontal="true"
                      :disabled="
                        ['andreas', 'matthias'].indexOf(
                          $store.getters.getUser.username
                        ) == -1
                      "
                    ></form-input>
                    <form-input
                      label="SITE-APOPOINT-URL"
                      :inputType="text"
                      v-model="siteCatalog.site.apopointUrl"
                      :is-horizontal="true"
                    ></form-input>

                    <!-- apotheken verknüpfungen -->
                    <apotheke-bnums
                      v-if="mainTab == 'APOPOINT'"
                      :siteID="siteID"
                      @input="updateNightDutySites"
                    ></apotheke-bnums>
                  </div>

                  <div class="section-header">
                    <label-name
                      labelKey="SITE-APOPOINT-HEADING-CHILDREN"
                    ></label-name>
                  </div>

                  <div class="section" v-show="!isLoading">
                    <!-- child apotheken verknüpfungen -->
                    <apotheke-children
                      v-if="mainTab == 'APOPOINT'"
                      :children="siteChildren"
                      :siteID="siteID"
                      :key="siteChildren"
                    ></apotheke-children>
                  </div>

                  <div class="section-header">
                    <label-name
                      labelKey="SITE-APOPOINT-HEADING-SHOP_SETTINGS"
                    ></label-name>
                  </div>

                  <div class="section">
                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE-APOPOINT-HAS_HERBA_ASSORTMENT"
                        ></label-name>
                      </div>
                      <div class="control">
                        <b-switch
                          v-model.sync="siteCatalog.site.hasHerbaAssortment"
                          type="primary"
                          size="small"
                          :disabled="isReadOnly"
                        ></b-switch>
                      </div>
                    </div>

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE-APOPOINT-HAS_CUSTOM_ASSORTMENT"
                        ></label-name>
                      </div>
                      <div class="control">
                        <b-switch
                          v-model.sync="siteCatalog.site.hasCustomAssortment"
                          type="primary"
                          size="small"
                          :disabled="isReadOnly"
                        ></b-switch>
                      </div>
                    </div>

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE-APOPOINT-MERCHANT"
                        ></label-name>
                      </div>
                      <div class="control">
                        <b-switch
                          v-model.sync="siteCatalog.site.hasGoogleMerchant"
                          type="primary"
                          size="small"
                          :disabled="isReadOnly"
                        ></b-switch>
                      </div>
                    </div>

                    <form-input
                      v-if="siteCatalog.site.hasGoogleMerchant"
                      label="SITE-APOPOINT-GOOGLE_MERCHANT_STORECODE"
                      :inputType="text"
                      v-model="siteCatalog.site.googleMerchantStoreCode"
                      :is-horizontal="true"
                    ></form-input>

                    <form-input
                      label="SITE-APOPOINT-EXCLUDED_MANUFACTURERS"
                      :inputType="text"
                      v-model="siteCatalog.site.apoPointExcludedManufacturers"
                      :is-horizontal="true"
                    ></form-input>

                    <!--
									<div class="control is-horizontal">
										<div class="control-label">
											<label-name labelKey="PIM-SETTINGS-TOP_PRODUCTS"></label-name>
										</div>
										<div class="control">
											<b-switch v-model.sync="siteCatalog.site.catTopProducts" type="primary" size="small" :disabled="isReadOnly"></b-switch>
										</div>
									</div>

									<div class="control is-horizontal">
										<div class="control-label">
											<label-name labelKey="PIM-SETTINGS-APOTHEKENKATALOG"></label-name>
										</div>
										<div class="control">
											<b-switch v-model.sync="siteCatalog.site.catApothekenkatalog" type="primary" size="small" :disabled="isReadOnly"></b-switch>
										</div>
									</div>
									-->

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE-APOPOINT-DRUGS_MAX_ALLOWED_QTY"
                        ></label-name>
                      </div>
                      <span class="control select">
                        <select
                          v-model="siteCatalog.site.apoPointDrugsMaxAllowedQty"
                          :disabled="isReadOnly"
                        >
                          <option
                            v-for="option in apoPointDrugsMaxAllowedQtyOptions"
                            :value="option.value"
                            :key="option.value"
                          >
                            {{ option.name }}
                          </option>
                        </select>
                      </span>
                    </div>
                  </div>

                  <!-- DEACTIVATED!!! (display: none;) -->
                  <div class="section" style="display: none">
                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE-APOPOINT-NIGHT_DUTY_GROUP"
                        ></label-name>
                      </div>
                      <span class="control select">
                        <select
                          @change="submitForm(true)"
                          v-model="siteCatalog.site.nightDutyGroup"
                          :disabled="isReadOnly"
                        >
                          <option
                            v-for="option in nightDutyGroupOptions"
                            :value="option.value"
                          >
                            {{ option.name }}
                          </option>
                        </select>
                      </span>
                    </div>

                    <!-- Upload Field -->
                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE-APOPOINT-NIGHT_DUTY_DATES"
                        ></label-name>
                      </div>

                      <div class="control">
                        <!-- 			v-on:vdropzone-file-added="dzNightDutyFileAdded" -->
                        <vue-dropzone
                          ref="dzNightDutyDates"
                          id="dzNightDutyDates"
                          url="fileProcessing/upload?preset=processSiteNightDutyDates"
                          :formDataAppend="[{ siteId: siteCatalog.site.id }]"
                          :autoProcessQueue="false"
                          :maxFiles="1"
                          dictDefaultMessage="<i class='fa fa-cloud-upload'></i>CSV hochladen"
                          v-on:vdropzone-file-added="dzNightDutyFileAdded"
                          v-on:vdropzone-sending="dzNightDutySendingEvent"
                          v-on:vdropzone-success="dzNightDutySuccess"
                          dzClass="default"
                        >
                        </vue-dropzone>

                        <modal
                          title="Upload Nachtdienstdaten"
                          :width="520"
                          transition="fadeDown"
                          :show-ok="false"
                          :show-cancel="false"
                          :is-show="showModal"
                          :show-footer="false"
                          :backdrop-closable="false"
                          @close="showModal = false"
                          class="vcenter"
                        >
                          <div
                            style="
                              min-height: 100px;
                              display: flex;
                              flex-direction: column;
                              align-items: center;
                              justify-content: center;
                            "
                          >
                            <div style="margin-bottom: 12px">
                              Sollen ggf. bestehende Nachtdienst-Daten
                              überschrieben werden?
                            </div>
                            <div class="buttons">
                              <div
                                class="button is-light"
                                @click="dzNightDutySend(false)"
                                style="margin-right: 5px"
                              >
                                nein
                              </div>
                              <div
                                class="button is-primary"
                                @click="dzNightDutySend(true)"
                              >
                                ja, überschreiben
                              </div>
                            </div>
                          </div>
                        </modal>
                      </div>
                    </div>
                  </div>

                  <!--
								<div class="section">

									<form-input label="SITE-APOPOINT-EXCLUDED_MANUFACTURERS" :inputType="text" v-model="siteCatalog.site.apoPointExcludedManufacturers" :is-horizontal="true"></form-input>

									<div class="control is-horizontal">
										<div class="control-label">
											<label-name labelKey="PIM-SETTINGS-TOP_PRODUCTS"></label-name>
										</div>
										<div class="control">
											<b-switch v-model.sync="siteCatalog.site.catTopProducts" type="primary" size="small" :disabled="isReadOnly"></b-switch>
										</div>
									</div>

									<div class="control is-horizontal">
										<div class="control-label">
											<label-name labelKey="PIM-SETTINGS-APOTHEKENKATALOG"></label-name>
										</div>
										<div class="control">
											<b-switch v-model.sync="siteCatalog.site.catApothekenkatalog" type="primary" size="small" :disabled="isReadOnly"></b-switch>
										</div>
									</div>


								</div>
								-->

                  <div class="section-header">
                    <label-name
                      labelKey="SITE-APOPOINT-HEADING-INTERFACES"
                    ></label-name>
                  </div>
                  <div class="section">
                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name labelKey="SITE-APOPOINT-ERP"></label-name>
                      </div>
                      <span class="control select">
                        <select
                          v-model="siteCatalog.site.erp"
                          :disabled="isReadOnly"
                          @change="changeERP()"
                        >
                          <option
                            v-for="option in erpOptions"
                            :value="option.value"
                          >
                            {{ option.name }}
                          </option>
                        </select>
                      </span>
                    </div>

                    <template
                      v-if="
                        siteCatalog.site.erp != null &&
                        siteCatalog.site.erpAccountData
                      "
                    >
                      <template v-if="siteCatalog.site.erp === 'apotronik'">
                        <form-input
                          label="SITE-APOPOINT-ERP-KEY"
                          :inputType="text"
                          v-model.trim()="siteCatalog.site.erpAccountData.key"
                          :is-horizontal="true"
                        ></form-input>
                        <form-input
                          label="SITE-APOPOINT-ERP-EMAIL"
                          :inputType="text"
                          v-model.trim()="siteCatalog.site.erpAccountData.email"
                          :is-horizontal="true"
                        ></form-input>
                      </template>

                      <template v-else-if="siteCatalog.site.erp === 'avs'">
                        <form-input
                          label="SITE-APOPOINT-ERP-KEY"
                          :inputType="text"
                          v-model="siteCatalog.site.erpAccountData.key"
                          :is-horizontal="true"
                        ></form-input>
                        <form-input
                          label="SITE-APOPOINT-ERP-HOST"
                          :inputType="text"
                          v-model="siteCatalog.site.erpAccountData.host"
                          :is-horizontal="true"
                        ></form-input>
                        <form-input
                          label="SITE-APOPOINT-ERP-USERNAME"
                          :inputType="text"
                          v-model="siteCatalog.site.erpAccountData.username"
                          :is-horizontal="true"
                        ></form-input>
                        <form-input
                          label="SITE-APOPOINT-ERP-PASSWORD"
                          :inputType="text"
                          v-model="siteCatalog.site.erpAccountData.password"
                          :is-horizontal="true"
                        ></form-input>
                        <form-input
                          label="SITE-APOPOINT-ERP-APPLICATION"
                          :inputType="text"
                          v-model="siteCatalog.site.erpAccountData.application"
                          :is-horizontal="true"
                        ></form-input>
                        <form-input
                          label="SITE-APOPOINT-ERP-CLIENT"
                          :inputType="text"
                          v-model="siteCatalog.site.erpAccountData.client"
                          :is-horizontal="true"
                        ></form-input>
                      </template>

                      <template v-else-if="siteCatalog.site.erp == 'ait2'">
                        <form-input
                          label="SITE-APOPOINT-ERP-KEY"
                          :inputType="text"
                          v-model="siteCatalog.site.erpAccountData.key"
                          :is-horizontal="true"
                        ></form-input>
                        <form-input
                          label="SITE-APOPOINT-ERP-UPLOAD_KEY"
                          :inputType="text"
                          v-model="siteCatalog.site.erpAccountData.uploadKey"
                          :is-horizontal="true"
                        ></form-input>
                      </template>

                      <template v-else-if="siteCatalog.site.erp === 'ait2api'">
                        <form-input
                          inputType="password"
                          v-model="siteCatalog.site.apopointConfig.ait2apiKey"
                          :is-horizontal="true"
                          isReadOnly
                          label="SITE-APOPOINT-AIT2APIKEY"
                          :revealPassword="revealPassword"
                        >
                        </form-input>

                        <div
                          class="control is-horizontal"
                          style="margin-top: -10px"
                        >
                          <div class="control-label"></div>

                          <div class="control">
                            <a
                              class="button is-primary"
                              @click="generateId(32)"
                            >
                              <lang
                                labelKey="SITE-APOPOINT-BTN-GENERATE_AIT2APIKEY"
                              >
                              </lang>
                            </a>
                          </div>
                        </div>
                      </template>

                      <div
                        class="control is-horizontal"
                        v-if="
                          siteCatalog.site.erpAccountData &&
                          siteCatalog.site.erpAccountData.read
                        "
                      >
                        <div class="control-label">
                          <label-name
                            labelKey="SITE-APOPOINT-ERP-READ"
                          ></label-name>
                        </div>
                        <div class="control">
                          <b-switch
                            v-model.sync="siteCatalog.site.erpAccountData.read"
                            type="primary"
                            size="small"
                            :disabled="isReadOnly"
                          ></b-switch>
                        </div>
                      </div>

                      <div class="control is-horizontal">
                        <div class="control-label">
                          <label-name
                            labelKey="SITE-APOPOINT-ERP-WRITE"
                          ></label-name>
                        </div>
                        <div class="control">
                          <b-switch
                            v-model.sync="siteCatalog.site.erpAccountData.write"
                            type="primary"
                            size="small"
                            :disabled="isReadOnly"
                          ></b-switch>
                        </div>
                      </div>

                      <div class="control is-horizontal">
                        <div class="control-label">
                          <label-name
                            labelKey="SITE-APOPOINT-ERP-USE_OFFERS"
                          ></label-name>
                        </div>
                        <div class="control">
                          <b-switch
                            v-model.sync="siteCatalog.site.useErpOffers"
                            type="primary"
                            size="small"
                            :disabled="isReadOnly"
                          ></b-switch>
                        </div>
                      </div>
                    </template>
                  </div>

                  <div class="section">
                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE-APOPOINT-WAREHOUSE"
                        ></label-name>
                      </div>
                      <span class="control select">
                        <select
                          v-model="siteCatalog.site.warehouse"
                          :disabled="isReadOnly"
                        >
                          <option
                            v-for="option in warehouseOptions"
                            :value="option.value"
                          >
                            {{ option.name }}
                          </option>
                        </select>
                      </span>
                    </div>

                    <div class="control is-horizontal">
                      <div class="control-label">
                        <label-name
                          labelKey="SITE-APOPOINT-WAREHOUSE-ALT"
                        ></label-name>
                      </div>
                      <span class="control select">
                        <select
                          v-model="siteCatalog.site.warehouseAlternative"
                          :disabled="isReadOnly"
                        >
                          <option
                            v-for="option in [
                              { value: null, name: '--' },
                              ...warehouseOptions,
                            ]"
                            :value="option.value"
                          >
                            {{ option.name }}
                          </option>
                        </select>
                      </span>
                    </div>
                  </div>
                </tab-item>

                <!-- tab APOPOINT CONFIG -->
                <tab-item
                  :label="$t('APO_TAB-APOPOINT_CONFIG')"
                  v-if="tabs.includes('apopointConfig')"
                >
                  <template v-if="activeTab == 'apopointConfig'">
                    <pharmacy-pwa-config
                      :afterWizardCollapsed="afterWizardCollapsed"
                      v-model="siteCatalog.site.apopointConfig"
                      :site="siteCatalog.site"
                      :loyaltyPointsPerEuro.sync="
                        siteCatalog.site.loyaltyPointsPerEuro
                      "
                      :erpOptions="erpOptions"
                      @update:loyaltyPointsPerEuro="
                        onLoyaltyPointsPerEuroUpdate
                      "
                      @update:multipliers-data="
                        onLoyaltyPointsMultipliersUpdate
                      "
                    >
                    </pharmacy-pwa-config>
                  </template>
                </tab-item>

                <!-- tab PIM CAMPAIGNS  -->
                <tab-item
                  :label="$t('APO_TAB-APOPOINT_CAMPAIGNS')"
                  v-if="tabs.includes('apopointCampaigns')"
                >
                  <template v-if="activeTab == 'apopointCampaigns'">
                    <campaigns
                      :embeddedView="true"
                      :givenSiteId="siteCatalog.site.id"
                    ></campaigns>
                  </template>
                </tab-item>

                <!-- tab KOMM PLATTFORM  -->
                <tab-item
                  :label="$t('APO_TAB-COMPLAT')"
                  v-if="tabs.includes('comPlat')"
                >
                </tab-item>

                <!-- tab MARKETING COCKPIT  -->
                <tab-item
                  :label="$t('APO_TAB-MARKETING_COCKPIT')"
                  v-if="tabs.includes('marketingCockpit')"
                >
                </tab-item>
              </tabs>
            </div>

            <!-- COMMENTS -->
            <comments
              v-if="
                userRole != 'Kundenbetreuer' &&
                mainTab == 'APOKAT' &&
                (siteCatalog.quantity != 0 || siteCatalog.rebateInKind != 0)
              "
              :threadID.sync="siteCatalog.site.thread"
              :api="'site/' + siteCatalog.site.id"
            >
            </comments>
          </div>
          <!-- // col-main -->

          <!-- COL ASIDE -->
          <div class="col-aside">
            <affix :offset="50">
              <div style="display: flex; flex-direction: column; gap: 8px">
                <template v-if="userRole != 'Kundenbetreuer'">
                  <!-- SAVE BTN -->
                  <custom-button
                    type="blue"
                    icon="icon-ak-speichern"
                    name="SITE_BUTTON_SAVE"
                    :loading="isSaving"
                    @click.native="submitForm()"
                  ></custom-button>

                  <!-- IMPERSONATE BTN -->
                  <impersonate-button
                    :siteId="parseInt($route.params.siteID)"
                  ></impersonate-button>
                </template>

                <!-- APOKAT -->
                <template v-if="mainTab == 'APOKAT'">
                  <!-- STATUS -->
                  <div class="sidebox" v-if="userRole == 'Administrator'">
                    <div class="heading">
                      <lang labelKey="SITE_CATALOG-STATUS"></lang>
                    </div>
                    <p class="control">
                      <span class="select is-normal">
                        <select
                          v-model="siteCatalog.status"
                          @change="changeSiteCatalogStatus(siteCatalog.status)"
                        >
                          <option
                            v-for="(status, key) in siteCatalogStatus"
                            :value="status.id"
                          >
                            {{ $t("SITE_CATALOG-SELECT_BOX-STATUS-" + key) }}
                          </option>
                        </select>
                      </span>
                    </p>
                  </div>

                  <!-- PRINT BTN -->
                  <custom-button
                    name="SITE-PRINT"
                    type="dark"
                    icon="icon-ak-print"
                    @click.native="printPharmacy()"
                    v-if="
                      userRole == 'Administrator' &&
                      ['matthias', 'matthias-test'].indexOf(
                        this.activeUser.username
                      )
                    "
                  ></custom-button>

                  <!-- EXPORT BTN -->
                  <export-button
                    export="successControl"
                    :exportId="$route.params.siteID"
                    btnTitle="SITE_BTN_EXP_SUCCESS_CONTROL"
                    modalTitle="MODAL_HEADER-EXPORT_SUCCESS_CONTROL"
                    v-if="
                      siteCatalog.site.hasPerformanceDocument &&
                      (userRole == 'Administrator' ||
                        userRole == 'Kundenbetreuer')
                    "
                  ></export-button>

                  <!-- IMPORT NIGHT DUTY -->
                  <!--
								<upload-box
								 	type="button"
									:url= "$config.api + 'fileProcessing/upload?preset=processSitePerformanceImport'"
									:thumbnailWidth="145"
									:thumbnailHeight="67"
									label='Nachtdienste hochladen'>
								</upload-box>
								-->
                </template>

                <!-- GENERAL && APOPOINT -->
                <template
                  v-else-if="mainTab == 'GENERAL' || mainTab == 'APOPOINT'"
                >
                  <button
                    class="button"
                    @click="openLink(siteCatalog.site.apopointUrl)"
                    v-if="siteCatalog.site.apopointUrl"
                  >
                    <span class="material-symbols-outlined">ungroup</span>
                    <!-- <span class="icon is-small"><i class="fa fa-external-link"></i></span> -->
                    <span>
                      <lang labelKey="BTN-OPEN-WEBSITE"></lang>
                    </span>
                  </button>
                </template>

                <!-- APOPOINT -->
                <template v-if="mainTab == 'APOPOINT'">
                  <button
                    class="button"
                    @click="
                      openLink(siteCatalog.site.apopointUrl + '/wp-admin/')
                    "
                    v-if="siteCatalog.site.apopointUrl"
                  >
                    <!-- <span class="icon is-small"><i class="fa fa-external-link"></i></span> -->
                    <span class="material-symbols-outlined">ungroup</span>
                    <span>
                      <lang labelKey="BTN-OPEN-WEBSITE-WP_ADMIN"></lang>
                    </span>
                  </button>

                  <button
                    class="button"
                    @click="openLink(siteCatalog.site.apopointDevUrl)"
                    v-if="siteCatalog.site.apopointDevUrl"
                  >
                    <!-- <span class="icon is-small"><i class="fa fa-external-link"></i></span> -->
                    <span class="material-symbols-outlined">ungroup</span>
                    <span>
                      <lang labelKey="BTN-OPEN-WEBSITE-DEV"></lang>
                    </span>
                  </button>

                  <button
                    class="button"
                    @click="
                      $router.push({
                        name: 'pimProducts',
                        params: { pharmacy: siteCatalog.site.id },
                      })
                    "
                  >
                    <span>
                      <lang labelKey="BTN-PHARMACY_PRODUCTS"></lang>
                    </span>
                  </button>
                  <!-- GO LIVE BUTTON -->
                  <button
                    class="button btn-go-live"
                    v-if="showGoLiveButton"
                    @click="showGoLiveWizard = true"
                  >
                    <span class="material-symbols-outlined">rocket_launch</span>
                    <span><lang labelKey="BTN-GOLIVE-WIZARD" /></span>
                  </button>
                  <!-- Go Live Wizard -->
                  <GoLiveWizard
                    v-if="showGoLiveWizard"
                    :site-id="siteCatalog.site.id"
                    :page-title="siteCatalog.site.name"
                    @close="showGoLiveWizard = false"
                    @wizard-completed="onGoLiveCompleted"
                  />
                </template>
                <!-- Wizard -->
                <template v-if="mainTab == 'GENERAL'">
                  <!-- SETUP WIZARD BUTTON -->
                  <button
                    class="button"
                    @click="showWizard = true"
                    v-if="showSetupWizardButton"
                  >
                    <span class="material-symbols-outlined">wand_stars</span>
                    <span>
                      <lang labelKey="BTN-OPEN-WIZARD" />
                    </span>
                  </button>

                  <!-- Setup Wizard -->
                  <SetupWizard
                    v-if="showWizard"
                    :site-id="siteCatalog.site.id"
                    :page-title="siteCatalog.site.name"
                    @close="showWizard = false"
                    @wizard-completed="onWizardCompleted"
                  />
                </template></div
            ></affix>
          </div></div></template
    ></template>
  </div>
</template>

              </div>
            </affix>
          </div>
          <!-- // col-aside -->
        </div>
      </template>
    </template>
  </div>
</template>


<script>
import contentSegment from "./contentSegment";
import LogChanges from "../utils/incl-logChanges";
import orderHistory from "./incl-orderHistory";
import comments from "../utils/incl-comments";
import assets from "../utils/incl-assets";
import exportButton from "../utils/exportButton";
import vue2Dropzone from "../utils/dropzoneWrapper";
import editPerson from "../utils/editPersonModal";
import calendar from "../calendar/incl-calendar";
import mutationPreviewDropzone from "./mutationPreviewDropzone";
// import uploadBox from '../utils/uploadBox';
import campaigns from "../pim/campaigns/incl-pimCampaigns";
import pharmacyOpeningHours from "./incl-pharmacy-opening-hours";
import pharmacyPwaConfig from "./incl-pharmacy-pwa-config";

import apothekeBnums from "./incl-apotheke-bnums.vue";
import apothekeChildren from "./incl-apotheke-children.vue";
import firstLevelNav from "./first-level-nav.vue";

import SetupWizard from "./SetupWizard.vue";
import GoLiveWizard from "./GoLiveWizard.vue";
export default {
  name: "site",

  components: {
    contentSegment,
    exportButton,
    vueDropzone: vue2Dropzone,
    comments,
    LogChanges,
    assets,
    calendar,
    mutationPreviewDropzone,
    // uploadBox,
    editPerson,
    apothekeBnums,
    apothekeChildren,
    firstLevelNav,
    campaigns,
    orderHistory,
    pharmacyOpeningHours,
    pharmacyPwaConfig,
    SetupWizard,
    GoLiveWizard,
  },

  data() {
    return {
      siteID: null,
      siteCatalog: null,
      siteChildren: null,
      openingHours: [],
      newContentField: {},
      afterWizardCollapsed: false,
      isSaving: false,
      isLoading: true,

      // showCalendar: false,
      // showLogs: false,
      statusTemp: null,
      showPersonModal1: false,
      showPersonModal2: false,

      mainTab: "GENERAL",

      showModal: false,
      clearNightDutyData: 0,
      activeTab: null,
      revealPassword: false,

      showWizard: false,
      showGoLiveWizard: false,
    };
  },

  created() {
    switch (this.$route.name) {
      case "apopointDetail":
        this.mainTab = "APOPOINT";
        break;
      case "apotheken":
        this.mainTab = "GENERAL";
        break;
      case "catalogPharmacyDetail":
        this.mainTab = "APOKAT";
        break;
    }
    // fetch the APO ID from router
    if (
      this.$route.params.siteID &&
      Number.isInteger(parseInt(this.$route.params.siteID))
    ) {
      this.siteID = parseInt(this.$route.params.siteID);
      this.fetchData();

      // no (valid) apo ID
    } else {
      this.$notify.open({
        content: "Fehler: es wurde keine valide APO ID übergeben!",
        type: "danger",
      });
    }
  },

  mounted() {},
  watch: {
    "siteCatalog.status"(val1, val2) {
      this.statusTemp = val2;
    },

    "siteCatalog.site.isChefinfoNewsletterRecipient"(val) {
      if (
        val == true &&
        this.siteCatalog.site.chefinfoNewsletterRecipient == null
      ) {
        this.siteCatalog.site.chefinfoNewsletterRecipient = {
          email: null,
          firstname: null,
          lastname: null,
          title: null,
          gender: null,
        };
      }
    },

    "siteCatalog.site.isBeiratsNewsNewsletterRecipient"(val) {
      if (
        val == true &&
        this.siteCatalog.site.beiratsNewsNewsletterRecipient == null
      ) {
        this.siteCatalog.site.beiratsNewsNewsletterRecipient = {
          email: null,
          firstname: null,
          lastname: null,
          title: null,
          gender: null,
        };
      }
    },
  },

  computed: {
    showSetupWizardButton() {
      if (!this.siteCatalog || !this.siteCatalog.site) {
        return false;
      }

      const site = this.siteCatalog.site;
      const forcedWizardUrl =
        "https://meine-lieblingsapotheke-dev.sanodattest.bdata.at/protected";
      const normalizedUrl = (site.apopointUrl || "").replace(/\/+$/, "");

      return site.hasApoPoint || normalizedUrl === forcedWizardUrl;
    },
    showGoLiveButton() {
      console.log("siteCatalog:", this.siteCatalog);

      if (!this.siteCatalog || !this.siteCatalog.site) {
        console.log("site is missing");
        return false;
      }

      const site = this.siteCatalog.site;

      console.log("site:", site);
      console.log("hasApoPoint:", site.hasApoPoint);
      console.log("apopointUrl:", site.apopointUrl);

      return (
        site.hasApoPoint &&
        site.apopointUrl &&
        site.apopointUrl.indexOf(".bdata.at") !== -1
      );
    },
    tabs() {
      let tabs;

      if (this.mainTab == "GENERAL") {
        tabs = ["baseData", "tabOpeningHours"]; // "comPlat", "marketingCockpit"
      } else if (this.mainTab == "APOKAT") {
        tabs = [
          "baseData",
          "apokat",
          "apokatMutationen",
          "apokatDaten",
          "apokatKontrolle",
          "apokatLogs",
        ];
        if (
          this.userRole == "Kundenbetreuer" ||
          ["pv", "ej", "andreas", "matthias"].indexOf(
            this.activeUser.username
          ) > -1
        ) {
          tabs.push("Calendar");
        }
      } else if (this.mainTab == "APOPOINT") {
        // in case this pharmacy is a "child" pharmacy of another pharmacy, we only want to show the pwa-config tab!
        if (this.siteCatalog.site.parent != null) {
          tabs = ["apopointConfig"];
        } else {
          tabs = [
            "baseData",
            "tabOpeningHours",
            "apopointShopSettings",
            "apopointConfig",
            "apopointCampaigns",
          ];
        }

        /*
				if(['m.holzinger', 'andreas', 'matthias'].indexOf(this.activeUser.username) > -1) {
					tabs = ["baseData", "tabOpeningHours", "apopointShopSettings", "apopointConfig", "apopointCampaigns"];
					// tabs.push('apopointConfig');
					// tabs.splice(tabs.length-1, 0, 'apopointConfig');
				} else {
					tabs = ["baseData", "tabOpeningHours", "apopointShopSettings", "apopointCampaigns"];
				}
				*/
      }

      return tabs;
    },

    isSupplement() {
      return this.$store.getters.getCurrentCatalog
        .hasCustomizationModeSupplement;
    },

    siteCatalogStatus() {
      return this.$store.getters.getTermsByTaxonomy("SITE_CATALOG_STATUS");
    },

    siteCatalogContentCategories() {
      let cats = this.$store.getters.getTermsByTaxonomy(
        "SITE_CATALOG_CONTENT_CATEGORIES"
      );
      return Object.values(cats).filter((cat) => {
        if (this.isSupplement) {
          return (
            this.siteCatalog.package.data.siteCatalogContentCategoriesSupplement.indexOf(
              cat.id
            ) != -1 &&
            (cat.name != "CONTACT_CARD" ||
              (this.siteCatalog.voucherPackage != null &&
                this.siteCatalog.voucherPackage.name == "NO_VOUCHERS"))
          );
        } else {
          return (
            this.siteCatalog.package.data.siteCatalogContentCategories.indexOf(
              cat.id
            ) != -1 &&
            (cat.name != "CONTACT_CARD" ||
              (this.siteCatalog.voucherPackage != null &&
                this.siteCatalog.voucherPackage.name == "NO_VOUCHERS"))
          );
        }
      });
    },

    apopointTypes() {
      return this.$store.getters.getTermsByTaxonomy("APOPOINT_TYPES");
    },

    siteCatalogCustomizations() {
      return this.$store.getters.getTermsByTaxonomy(
        "SITE_CATALOG_CUSTOMIZATIONS"
      );
    },

    siteCatalogCustomizationExpenses() {
      return this.$store.getters.getTermsByTaxonomy(
        "SITE_CATALOG_CUSTOMIZATION_EXPENSES"
      );
    },

    siteCatalogCustomizationPackages() {
      return this.$store.getters.getTermsByTaxonomy(
        "SITE_CATALOG_CUSTOMIZATION_PACKAGES"
      );
    },

    voucherPackages() {
      return this.$store.getters.getTermsByTaxonomy("VOUCHER_PACKAGES");
    },

    personGenders() {
      return this.$store.getters.getTermsByTaxonomy("PERSON_GENDERS");
    },

    isReadOnly() {
      return this.userRole == "Kundenbetreuer";
    },

    erpOptions() {
      return [
        {
          name: "keine",
          value: null,
        },
        {
          name: "Apotronik",
          value: "apotronik",
        },
        {
          name: "AVS",
          value: "avs",
        },
        {
          name: "AIT2",
          value: "ait2",
        },
        {
          name: "AIT2-API",
          value: "ait2api",
        },
      ];
    },

    nightDutyGroupOptions() {
      let options = [];

      for (let i = 1; i <= 10; i++) {
        options.push({
          name: "N" + i,
          value: "N" + i,
        });
      }

      return options;
    },

    warehouseOptions() {
      var warehouses = [];

      for (var key in this.$store.getters.getTermsByTaxonomy("WAREHOUSES")) {
        let w = this.$store.getters.getTermsByTaxonomy("WAREHOUSES")[key];
        warehouses.push({
          value: w.id,
          name: w.name,
        });
      }

      return warehouses;
    },

    apopointTypesOptions() {
      var types = [];

      for (var key in this.apopointTypes) {
        let t = this.apopointTypes[key];
        types.push({
          value: t.id,
          name: t.name,
          displayName: this.$t("APOPOINT-TYPE-" + t.name),
        });
      }

      return types;
    },

    apoPointDrugsMaxAllowedQtyOptions() {
      var options = [
        {
          name: "Standard",
          value: null,
        },
        {
          name: "unlimitiert",
          value: -1,
        },
      ];

      for (let i = 1; i <= 10; i++) {
        options.push({
          name: i,
          value: i,
        });
      }

      return options;
    },
  },

  directives: {
    isoToString(el, binding) {
      if (el.value.indexOf("T") > -1) {
        var time = el.value.split("T")[1];
        el.value = time.substring(0, 5);
      }
    },
  },

  methods: {
    onWizardCompleted() {
      this.afterWizardCollapsed = true;
      const firstTab = document.getElementById("APOPOINT");
      if (!firstTab) return;

      firstTab.click();
      setTimeout(() => {
        const index = this.tabs.indexOf("apopointConfig");

        const tabHeaders = document.querySelectorAll(
          'ul.tab-list > li[role="tab"]'
        );

        if (tabHeaders[index]) {
          tabHeaders[index].click();

          if (this.$refs.baseDataCollapse) {
            this.$refs.baseDataCollapse.actived = true;
          }
        }

        document.body.style.overflow = "";

        this.showWizard = false;
      }, 200);
    },

    onLoyaltyPointsPerEuroUpdate(newValue) {
      this.siteCatalog.site = {
        ...this.siteCatalog.site,
        loyaltyPointsPerEuro: newValue,
      };
    },

    onLoyaltyPointsMultipliersUpdate(newValue) {
      this.siteCatalog.site = {
        ...this.siteCatalog.site,
        loyaltyPointMultipliers: newValue,
      };
    },

    // @update:multipliers-data="siteCatalog.site.loyaltyPointMultipliers = $event">
    generateId(length = 8) {
      var result = "";
      // var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var characters =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }

      if (!this.siteCatalog.site.apopointConfig) {
        this.siteCatalog.site.apopointConfig = {};
      }
      this.siteCatalog.site.apopointConfig.ait2apiKey = result;
      // this.revealPassword = true;
      this.$forceUpdate();
    },

    openLink(val) {
      window.open(val, "_blank");
      window.focus();
    },

    setMainTab(val) {
      this.mainTab = val;
    },

    updateNightDutySites(data) {
      this.siteCatalog.site.nightDutySites = data;
    },

    changeERP() {
      if (
        typeof this.siteCatalog.site.erpAccountData == "undefined" ||
        this.siteCatalog.site.erpAccountData == null
      ) {
        this.siteCatalog.site.erpAccountData = {};
      }
    },

    updateEmailContact(type, e) {
      this.siteCatalog.site[type] = e;
    },

    showContactPerson(person) {
      if (person == null) {
        return "";
      }

      let res = [];

      if (person.gender != null && person.gender != "") {
        let str = person.gender.name == "MALE" ? "Herr" : "Frau";
        res.push(str);
      }
      if (person.title != null && person.title != "") {
        res.push(person.title);
      }
      if (person.firstname != null && person.firstname != "") {
        res.push(person.firstname);
      }
      if (person.lastname != null && person.lastname != "") {
        res.push(person.lastname);
      }

      return res.join(" ");
    },

    getCreatedByName(user) {
      return user.person != null ? user.person.fullName : user.username;
    },

    async tabClicked(index) {
      if (this.tabs[index] == "apopointCampaigns") {
        this.activeTab = "apopointCampaigns";
      } else if (this.tabs[index] == "apokatLogs") {
        this.activeTab = "apokatLogs";
      } else if (this.tabs[index] == "Calendar") {
        this.activeTab = "Calendar";
      } else if (this.tabs[index] == "apokatKontrolle") {
        this.activeTab = "apokatKontrolle";
      } else if (this.tabs[index] == "tabOpeningHours") {
        this.activeTab = "tabOpeningHours";
      } else if (this.tabs[index] == "apopointConfig") {
        this.activeTab = "apopointConfig";
      } else {
        this.activeTab = null;
      }

      /*
			// !! take care!!
			// the index could change - e.g. if a tab with a lower index (0,1,...) is deactiavted
			// as long as there are no deactivated tabs before index 5,6 ... everything works fine
			// (this ugly solution is provisionally and is due to the fact how the tab-plugin works ...)
			switch(index) {
				case 5:
					this.showLogs = true;
					break;
				case 6:
					this.showCalendar = true;
					break;

			}
			*/
    },

    printPharmacy() {
      var url = window.location.href + "/print";
      var win = window.open(url, "_blank");
      win.focus();
    },

    removeAsset(payload) {
      let index = payload.index;
      this.siteCatalog.siteCatalogAssets.splice(index, 1);
    },

    changeSiteCatalogStatus(status) {
      if (status == 93) {
        this.$modal.open({
          title: "ACHTUNG",
          width: 520,
          content:
            "Hierbei wird eine E-Mail an die Apotheke gesendet. Möchten Sie fortsetzen?",
          backdropClosable: false,
          onOk: this.okCb,
          onCancel: this.cancelCb,
        });
      } else {
        this.submitForm();
      }
    },

    okCb() {
      this.submitForm();
    },

    cancelCb() {
      this.siteCatalog.status = this.statusTemp;
    },

    /*
		inCategory(category) {

			// return this.siteCatalog.package.data.siteCatalogContentCategories.indexOf(category.id) != -1;
			return this.siteCatalog.package.data.siteCatalogContentCategoriesSupplement.indexOf(category.id) != -1;

		},
		*/

    getImgUrl(customization) {
      return (
        this.$config.assets +
        customization.preview.path +
        "/" +
        customization.preview.filename
      );
    },

    getPdfDownloadUrl(customization) {
      var asset = this.getImgUrl(customization);
      return asset.substr(0, asset.lastIndexOf(".")) + ".pdf";
    },

    getPdfDownloadUrlVoucher(type = "front") {
      if (type == "front") {
        if (this.siteCatalog.voucherPreview == null) {
          return false;
        }

        var asset =
          this.$config.assets +
          this.siteCatalog.voucherPreview.path +
          "/" +
          this.siteCatalog.voucherPreview.filename;
        return asset.substr(0, asset.lastIndexOf(".")) + ".pdf";
      } else {
        if (this.siteCatalog.voucherBackPreview == null) {
          return false;
        }

        var asset =
          this.$config.assets +
          this.siteCatalog.voucherBackPreview.path +
          "/" +
          this.siteCatalog.voucherBackPreview.filename;
        return asset.substr(0, asset.lastIndexOf(".")) + ".pdf";
      }
    },

    // add and remove content Fields
    // ---------------------------------------------------------------------
    addContentField(contentField) {
      this.siteCatalog.siteCatalogContents.push(contentField);

      // save
      this.submitForm();
    },

    removeContentField(index) {
      // save
      this.submitForm();
    },

    contentFieldLabel(index) {
      return "Text " + ++index;
    },

    // add and remove openingHours
    // ---------------------------------------------------------------------
    addOpeningDay(index) {
      this.siteCatalog.site.openingHours.splice(index + 1, 0, {
        dayInWeek: this.siteCatalog.site.openingHours[index].dayInWeek,
        openTime: "",
        closeTime: "",
        site: this.siteCatalog.site.id,
      });
    },

    removeOpeningDay(index) {
      this.siteCatalog.site.openingHours.splice(index, 1);
    },

    // dropzone logo handling
    // ---------------------------------------------------------------------
    dzLogoSuccess(file) {
      var result = JSON.parse(file.xhr.response);

      this.siteCatalog.site.logoAsset = {
        filename: result.fileName,
        path: result.dir,
        uploadFilename: "logo",
      };

      // remove image from dropzone after some time
      var x = this.$refs.vueDropzoneLogo.$children[0];

      setTimeout(function () {
        x.removeFile(file);
      }, 1500);
    },

    dzNightDutyFileAdded(file) {
      this.showModal = true;
    },

    dzNightDutySend(clearNightDutyData) {
      this.clearNightDutyData = clearNightDutyData;
      this.showModal = false;
      this.$refs.dzNightDutyDates.$children[0].processQueue();
    },

    dzNightDutySendingEvent(file, xhr, formData) {
      formData.append("clear", this.clearNightDutyData);
    },

    dzNightDutySuccess(file) {
      var result = JSON.parse(file.xhr.response);
      var x = this.$refs.dzNightDutyDates.$children[0];

      setTimeout(function () {
        x.removeFile(file);
      }, 500);
    },

    // Processing of mutation preview complete, show previews
    // ---------------------------------------------------------------------

    dzMutationPreviewSucess() {
      this.axios
        .get(
          this.$config.api +
            "siteCatalog?include=siteCatalog.site,siteCatalog.siteCatalogCustomizations,siteCatalogCustomization.preview,siteCatalog.siteCatalogAssets,siteCatalogAsset.asset,siteCatalog.voucherPackage,siteCatalog.voucherBackPreview,siteCatalog.voucherPreview&filters[catalog]=" +
            this.catalogId +
            "&filters[site.id]=" +
            parseInt(this.$route.params.siteID)
        )

        .then((response) => {
          this.siteCatalog.voucherPreview =
            response.data.siteCatalog[0].voucherPreview;
          this.siteCatalog.voucherBackPreview =
            response.data.siteCatalog[0].voucherBackPreview;
          this.siteCatalog.siteCatalogCustomizations =
            response.data.siteCatalog[0].siteCatalogCustomizations;
        });
    },

    // dropzone catalog assets handlings
    // ---------------------------------------------------------------------
    dzSiteCatalogAssetSuccess(file, catId) {
      var result = JSON.parse(file.xhr.response);

      var newAsset = {
        category: catId,
        siteCatalog: this.siteCatalog.id,
        asset: {
          filename: result.fileName,
          path: result.dir,
          uploadFilename: file.name,
        },
      };

      // push newly created obj into assets Array
      this.siteCatalog.siteCatalogAssets.push(newAsset);

      // remove image from dropzone after some time
      var x = this.$refs["vueDropzone" + catId][0].$children[0];

      setTimeout(function () {
        x.removeFile(file);
      }, 2000);
    },

    submitForm(isSilent = false) {
      let opts = {};
      if (isSilent) {
        opts.isSilent = true;
      }

      this.isSaving = true;
      this.entityCreateOrUpdate("siteCatalog", this.siteCatalog, opts);
    },

    // Fetch Data
    // ---------------------------------------------------------------------
    async fetchData() {
      this.isLoading = true;

      const results = await this.entitiesGet([
        {
          key: "siteCatalog",
          params: {
            "filters[catalog.id]": this.catalogId,
            "filters[site.id]": this.siteID,
            include: [
              "siteCatalog.package",
              "siteCatalog.siteCatalogAssets",
              "siteCatalog.siteCatalogContents",
              "siteCatalog.site",
              "siteCatalog.siteCatalogCustomizations",
              "siteCatalogCustomization.preview",
              "siteCatalog.catalog",
              "siteCatalogAsset.asset",
              "siteCatalog.voucherPackage",
              "siteCatalog.voucherBackPreview",
              "siteCatalog.voucherPreview",
              //'site.loyaltyPointMultipliers',
              "site.openingHours",
              "site.accountManager",
              "site.logoAsset",
              "site.contactPerson",
              "site.emailContactPerson1",
              "site.emailContactPerson2",
              "site.chefinfoNewsletterRecipient",
              "site.beiratsNewsNewsletterRecipient",
              "site.nightDutySites",
              "site.apopointConfig",
              "person.gender",
              "person.createdBy",
            ].join(","),
          },
        },
      ]);

      this.siteCatalog = results.siteCatalog[0];

      // check if there are any child pharmacies connected
      // if so, store them in the "children" property of site
      const res = await this.axios.get(
        `${this.$config.api}site?filters[parent]=${this.siteID}`
      );

      if (res.data.site) {
        this.siteChildren = res.data.site.map((p) => ({
          name: p.name,
          id: p.id,
          zipcode: p.zipcode,
        }));
      }

      // make sure we have an (empty) object, if we need the apopointConfig property
      if (
        this.siteCatalog.site.parent != null &&
        this.siteCatalog.site.apopointConfig == null
      ) {
        this.siteCatalog.site.apopointConfig = {};
      }

      // set the voucher package of this site to "NO VOUCHERS" if voucherPackage == null
      if (this.siteCatalog.voucherPackage == null) {
        this.siteCatalog.voucherPackage = this.voucherPackages.NO_VOUCHERS;
      }

      /* was uncommented? */
      if (
        typeof this.siteCatalog.site.erpAccountData == "undefined" ||
        this.siteCatalog.site.erpAccountData == null
      ) {
        this.siteCatalog.site.erpAccountData = {};
      }

      // make sure the contact person is set, otherwise the binding fails
      if (!this.siteCatalog.site.contactPerson) {
        this.siteCatalog.site.contactPerson = {
          fullName: "",
        };
      }

      // make sure the account manager is set, otherwise the binding fails
      if (!this.siteCatalog.site.accountManager) {
        this.siteCatalog.site.accountManager = {
          fullName: "",
        };
      }

      // make sure loyaltyPointsPerEuro is set
      if (!this.siteCatalog.site.loyaltyPointsPerEuro) {
        this.siteCatalog.site.loyaltyPointsPerEuro = 1;
      }

      // prepare siteCatalogCustomization if necessary
      // we need to make sure we have three entries of the types U1_U4, U2 and US
      // these types are provided by the SITE-CATALOG-CUSTOMIZATIONS taxonomy

      Object.keys(this.siteCatalogCustomizations).forEach((key) => {
        // check if a customization of this type already exists, otherwise create one
        var siteCatalogCustomizationType = this.siteCatalogCustomizations[key],
          exists =
            this.siteCatalog.siteCatalogCustomizations.filter(
              (siteCatalogCustomization) => {
                return (
                  siteCatalogCustomization.type ==
                  siteCatalogCustomizationType.id
                );
              }
            ).length > 0;

        if (!exists) {
          this.siteCatalog.siteCatalogCustomizations.push({
            siteCatalog: this.siteCatalog.id,
            changeExpendituresAmount:
              this.siteCatalogCustomizationExpenses.NONE,
            type: siteCatalogCustomizationType.id,
          });
        }
      });

      if (!this.siteCatalog.site.openingHours.length) {
        var i;

        for (i = 0; i < 7; i++) {
          this.siteCatalog.site.openingHours.push({
            dayInWeek: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"][i],
            openTime: "08:00",
            closeTime: "18:00",
            site: this.siteCatalog.site.id,
          });
        }
      }

      this.siteCatalog.site.hasCustomAssortment = this.siteCatalog.site
        .hasCustomAssortment
        ? this.siteCatalog.site.hasCustomAssortment
        : true;

      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-go-live {
  background: linear-gradient(135deg, #27ae60, #2ecc71);
  color: #fff;
}

.btn-go-live:hover {
  filter: brightness(1.05);
}

.col-aside {
  padding-top: 20px;
}

.section {
  margin: 0 0 32px 0;
  padding: 24px 16px;
  width: 100%;
  max-width: 1024px;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.section-header {
  padding: 0 0 6px 0;
  text-transform: uppercase;

  .label {
    color: #999;
    // font-weight: normal !important;
  }
}

.previewWrapper {
  position: relative;
  padding: 12px;
  background: #f5f5f5;
  border-radius: 3px;
  border: 1px solid #f1f1f1;
  width: auto;
  height: auto;
  display: flex;
  flex-direction: column;

  .empty {
    height: auto;
  }

  .preview {
    width: 12vw;
    height: 12vw;
    position: relative;
    background-repeat: no-repeat;
    background-position: left;
    background-size: cover;
    overflow: hidden;
    border-radius: 0;
    margin-bottom: 8px;
  }

  &.isSupplement {
    .preview {
      background-size: contain;
      background-position: 50% 50%;
      width: 320px !important;
      height: 320px;
    }

    &.RESPONSE_CARD_FRONT,
    &.RESPONSE_CARD_BACK,
    &.CONTACT_CARD {
      .preview {
        /*width: 12vw !important;*/
        height: 680px;
      }
    }

    &.voucher {
      /*
				&:not(:first-child) {
					margin-left: 12px !important;
				}
				*/
      margin-bottom: 12px;

      .preview {
        /*width: 12vw !important;*/
        height: 680px;
      }

      &.VOUCHERS_6 {
        .preview {
          height: 339px;
        }
      }
    }
  }

  a.dlButton {
    position: relative;
    border-bottom: none !important;
    display: block;
    margin: 0 auto;
    padding: 0;
    text-align: center;
  }

  &.US_PAGE_1 .preview,
  &.US_PAGE_2 .preview {
    height: 13.5vw;
  }

  &.voucher .preview {
    height: auto;
  }

  &.voucher .preview.noImg {
    height: 12vw;
  }

  &.U1 .preview,
  &.US_PAGE_1 .preview {
    background-size: 200% auto;
    background-position: 0 0;
  }

  &.U2 .preview {
    background-size: 100% auto;
    background-position: 0 0;
  }

  &.U4 .preview,
  &.US_PAGE_2 .preview {
    background-size: 200% auto;
    background-position: right top;
  }

  .preview.noImg,
  &.U1 .preview[lazy="error"],
  &.U2 .preview[lazy="error"],
  &.U4 .preview[lazy="error"],
  &.US_PAGE_1 .preview[lazy="error"],
  &.US_PAGE_2 .preview[lazy="error"] {
    background: transparent url("../../assets/img/bg-preview_customization.jpg")
      center no-repeat !important;
    background-size: 100% !important;
  }

  &.U1 .preview[lazy="loading"],
  &.U2 .preview[lazy="loading"],
  &.U4 .preview[lazy="loading"],
  &.US_PAGE_1 .preview[lazy="loading"],
  &.US_PAGE_2 .preview[lazy="loading"] {
    background-position: 50% 50%;
    background-size: 100px !important;
  }
}

.contactPersonButtons {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  margin-left: 4px;

  .button {
    padding: 0 10px;
    font-size: 11px;
    height: 100%;
    margin: 0 1px;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>



<style scoped>
.tabs /deep/ ul.tab-list li:last-child {
  display: none !important;
}

.tabs.showTabApopoint /deep/ ul.tab-list li:last-child {
  display: block !important;
}

.data-table-main table tr th,
.data-table-main table tr td {
  text-align: center;
}

.data-table-main table tr td:nth-last-child(-n + 3) {
  text-align: right;
}

.control.separator {
  min-width: 0;
}

/* @overwrite */
.control.comments .smallView.commentsContainer {
  margin: 10px 0 !important;
  padding: 0;
  width: 100%;
}

.control.comments .NewComment .control {
  margin-bottom: 5px !important;
}

.control.buttons {
}

.control.buttons .button {
  height: 100%;
}

.control.buttons .button i {
  font-size: 11px;
}

.notice .notification.is-info {
  background-color: #f1f1f1;
  color: #666;
  width: 35vw;
  margin: 0 auto;
  text-align: left;
}
</style>

<style>
.modal-card-body .is-info {
  background-color: transparent !important;
}
</style>
